import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/Images/LOGOS/Docity_Logo.png";
import closeIcon from "./../../assets/Images/Navbar/close.png";
import { toast, ToastContainer } from "react-toastify";
import upload from "./../../assets/Images/Request_Property/upload.png";
import loader from "./../../assets/Images/Request_Property/Loader.gif";
import "./KnowYourProperty.css";
import "../Common/PrestigeStepper.css";
import "../SearchableSelect/SearchableSelect.css";
import PropertiesService from "../../Services/PropertiesService";
import { Name } from "ajv";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import close from "./../../assets/Images/Request_Property/close.png";
import { FaPlus } from "react-icons/fa";
import del from "./../../assets/Images/Request_Property/delete.png";
import add from "./../../assets/Images/Request_Property/add.png";
import { Button, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaChevronUp, FaChevronDown, FaPlusCircle } from "react-icons/fa";
import { ChevronUp, ChevronDown } from 'lucide-react';
import PaymentPreviewCard from "../PaymentPreviewCard/PaymentPreviewCard";
import Product from "../RazorPay";
import { getApiErrorMessage } from '../../utils/fileHelpers';
import { purgeExpiredUnpaidDrafts } from '../../utils/draftExpiry';
import FilePreview from "../Common/FilePreview";
import requestsService from "../../Services/requests";
const KnowYourProperty = ({ propertyRequestSwitch, closeModal, ShowPrevousData, editKypId }) => {
  const [documentFields, setDocumentsFields] = useState([
    { department: "", file: null, fields: {} },
  ]);

  const [loading, setLoader] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [draftData, setDraftData] = useState(null);

  const getKypDraftDocuments = (draft) => {
    const docs = [];
    if (draft?.futureOwnershipDoc?.[0]) {
      docs.push({ name: 'Future Ownership', url: draft.futureOwnershipDoc[0] });
    } else if (draft?.futureOwnershipDoc) {
      docs.push({ name: 'Future Ownership', url: typeof draft.futureOwnershipDoc === 'string' ? draft.futureOwnershipDoc : draft.futureOwnershipDoc.file || draft.futureOwnershipDoc.url });
    }
    if (draft?.ownerPhoto?.[0]) {
      docs.push({ name: 'Owner Photo', url: draft.ownerPhoto[0] });
    }
    if (draft?.mainElevation?.[0]) {
      docs.push({ name: 'Main Elevation', url: draft.mainElevation[0] });
    }
    if (draft?.Department_wise_Documents?.[0]?.files) {
      const filesObj = draft.Department_wise_Documents[0].files;
      if (Array.isArray(filesObj)) {
        filesObj.forEach(f => {
          if (f?.file) docs.push({ name: f.name || 'Document', url: f.file, previewUrl: f.previewUrl });
        });
      } else if (typeof filesObj === 'object') {
        Object.keys(filesObj).forEach(cat => {
          const filesArray = filesObj[cat];
          if (Array.isArray(filesArray)) {
            filesArray.forEach(f => {
              if (f?.file) docs.push({ name: f.name || 'Document', url: f.file, previewUrl: f.previewUrl });
            });
          }
        });
      }
    }
    return docs.slice(0, 3);
  };

  const [DepartMentLoading, setDepartMentLoading] = useState(false);
  const [categories1, setCategories1] = useState(["Category_1"]);
  const [activestepper, setActiveStepper] = useState(0);
  const [paymentStatusModel, setpaymentStatusModel] = useState(false);
  const [paymentDone, setpaymentDone] = useState(false);
  const [isPayLaterLoadingKyp, setIsPayLaterLoadingKyp] = useState(false);
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarOtp, setAadhaarOtp] = useState("");
  const [aadhaarReferenceId, setAadhaarReferenceId] = useState("");
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [isSendingAadhaarOtp, setIsSendingAadhaarOtp] = useState(false);
  const [isVerifyingAadhaarOtp, setIsVerifyingAadhaarOtp] = useState(false);
  const [aadhaarError, setAadhaarError] = useState("");
  const [aadhaarSuccessMessage, setAadhaarSuccessMessage] = useState("");
  const [showAadhaarOtpModal, setShowAadhaarOtpModal] = useState(false);
  const [editDocIndex, setEditDocIndex] = useState({});
  const [SuccessStatus, setSuccessStatus] = useState('');
  const [ShowUploadFiles, setShowUploadFiles] = useState('');
  const [fileInputs1, setFileInputs1] = useState({
    Category_1: [],
  });
  const currentYear = new Date().getFullYear();
  const maxDobDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
  const MAX_UPLOAD_SIZE_MB = 30;
  const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
  const availableYears = Array.from({ length: 200 }, (_, i) => currentYear - i);
  const [isOpen, setIsOpen] = useState(false);



  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleYearSelect = (year) => {
    setFormData((prev) => ({ ...prev, ownedSince: year }));
    setIsOpen(false);
  };
  const handleYearSelectbuildingage = (year) => {
    setFormData((prev) => ({ ...prev, buildingAge: year }));
    setIsOpen(false);
  };


  // Close dropdown if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const sanitizeFileInputs = (fileInputs) => {
    return Object.keys(fileInputs).reduce((acc, category) => {
      acc[category] = fileInputs[category].map((file) => {
        const { ref, ...sanitizedFile } = file;
        return sanitizedFile;
      });
      return acc;
    }, {});
  };

  const getActiveKypDrafts = async () => {
    const currentUser = JSON.parse(localStorage.getItem('userDetails'));
    if (!currentUser?.user_id) return [];

    const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
    const pendingDrafts = response?.data?.filter((x) => x.isFilled === false && x.userId === currentUser?.user_id) || [];
    const { activeDrafts } = await purgeExpiredUnpaidDrafts({
      items: pendingDrafts,
      deleteItem: 'kyp',
      deleteFn: PropertiesService.DeleteProperty,
    });
    return activeDrafts;
  };
  const categories = [
    "Legal Documents",
    "R And S",
    "Commercial",
    "Technical Documents",
  ];
  const [textInputs, setTextInputs] = useState({
    Category_1: "",
  });

  const calculateProgressWidth = () => {
    const totalSteps = 6;
    const filledCount = Object.keys(completedSteps).filter(
      (key) => completedSteps[key]
    ).length;
    const percent = (filledCount / totalSteps) * 100;
    return `${percent}%`;
  };

  const wrapperRef = useRef(null);
  const addConsultant = () => {
    setFormData({
      ...formData,
      consultants: [...formData.consultants, ""],
    });
  };
  const updateConsultant = (index, value) => {
    const updated = [...formData.consultants];
    updated[index] = value;
    setFormData({
      ...formData,
      consultants: updated,
    });
  };
  const removeConsultant = (index) => {
    const updated = formData.consultants.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      consultants: updated,
    });
  };

  const addContractor = () => {
    setFormData({
      ...formData,
      contractors: [...formData.contractors, ""],
    });
  };
  const updateContractor = (index, value) => {
    const updated = [...formData.contractors];
    updated[index] = value;
    setFormData({
      ...formData,
      contractors: updated,
    });
  };
  const removeContractor = (index) => {
    const updated = formData.contractors.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      contractors: updated,
    });
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const formatCategoryName = (category) => {
    if (typeof category === "string") {
      return category.replace(/\s+/g, "_");
    }
    return "";
  };
  const [fieldErrors, setFieldErrors] = useState({});

  const renderDepartmentFormat = () => {
    const currentCategory = categories1 ? categories1[activestepper] : categories1;
    const files = fileInputs1 ? fileInputs1[currentCategory] || [] : [];

    // Deduplicate selected options: find departments chosen in other categories
    const currentSearchTerm = (textInputs?.[currentCategory] || "").toLowerCase();
    const selectedInOtherCategories = (categories1 || [])
      .filter((cat) => cat !== currentCategory)
      .map((cat) => textInputs?.[cat])
      .filter(Boolean);

    const availableOptions = dummyData
      .filter((item) => item.toLowerCase().includes(currentSearchTerm))
      .filter((item) => !selectedInOtherCategories.includes(item));

    return (
      <div className="department-format-wrapper">
        <div className="searchable-select-container" ref={wrapperRef} style={{ marginBottom: '24px' }}>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="input-with-clear-icon">
                <input
                  type="text"
                  className="searchable-select-input"
                  placeholder="Select department name"
                  value={textInputs[currentCategory] || ""}
                  onChange={(e) => handleTextInputChange(currentCategory, e.target.value)}
                  onFocus={() => setShowDropdown(true)}
                />
                {textInputs[currentCategory] && (
                  <span
                    className="clear-icon"
                    onClick={() => {
                      handleTextInputChange(currentCategory, "");
                      handleSelect("", currentCategory);
                    }}
                  >
                    &times;
                  </span>
                )}
                {showDropdown && (
                  <ul className="searchable-select-dropdown">
                    {availableOptions.length > 0 ? (
                      availableOptions.map((item, index) => (
                        <li
                          key={index}
                          className="searchable-select-option"
                          onClick={() => {
                            handleSelect(item, currentCategory);
                            setShowDropdown(false);
                          }}
                        >
                          {item}
                        </li>
                      ))
                    ) : (
                      <li className="searchable-select-option" style={{ color: '#999', cursor: 'default' }}>No results found</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
        {fieldErrors[`${currentCategory}-departmentName`] && (
          <span className="error-text">{fieldErrors[`${currentCategory}-departmentName`]}</span>
        )}


        <div className="dept-grid" style={{
          display: files.length === 1 ? 'flex' : 'grid',
          justifyContent: files.length === 1 ? 'center' : undefined,
          alignItems: files.length === 1 ? 'center' : 'stretch'
        }}>
          {files.length > 0 ? (
            files.map((file, docIndex) => (
              <div key={file.id || `doc-${docIndex}`} className={`dept-card ${files.length === 1 ? 'single-card-horizontal' : ''}`} style={{ width: files.length === 1 ? '100%' : undefined, maxWidth: files.length === 1 ? '1100px' : undefined }}>
                <button
                  type="button"
                  className="removeIcon"
                  onClick={() => removeFileInput1(currentCategory, docIndex)}
                >
                  ✕
                </button>

                <div className="dept-card-content">
                  <div className="dept-left">
                    <div className={`dept-preview ${file.file ? 'has-file' : ''}`}>
                      {fieldErrors[`${currentCategory}-${docIndex}-file`] && (
                        <span className="error-text">
                          {fieldErrors[`${currentCategory}-${docIndex}-file`]}
                        </span>
                      )}
                      {file.loading ? (
                        <div className="loader-container">
                          <img src={loader} alt="Loading..." />
                          <p>Uploading...</p>
                        </div>
                      ) : file.file ? (
                        <FilePreview
                          url={file.file}
                          width="100%"
                          height={files.length === 1 ? '280px' : '120px'}
                          title="Document Preview"
                          className="dept-iframe"
                          style={{ border: "none" }}
                          isPreviewUrl={true}
                        />
                      ) : (
                        <div
                          className="dept-placeholder"
                          onClick={() => handleClick(file.ref)}
                        >
                          <img src={upload} width={40} alt="Upload Icon" />
                          <p>Upload Your Document</p>
                        </div>
                      )}
                    </div>
                    <input
                      type="file"
                      id={file.id}
                      style={{ display: "none" }}
                      ref={(el) => (file.ref = el)}
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv"
                      onChange={(e) => onFileChange(e, currentCategory, docIndex)}
                    />
                  </div>

                  <div className="dept-right">
                    {[
                      "Type Of Document",
                      "Department of Registration and Stamps",
                      "Date the Document was Issued",
                      "Name of Issuing Officer",
                      "Designation of Officer",
                      "Office Situated At",
                    ].map((field, i) => {
                      const fieldId = `field-${docIndex}-${i}`;
                      const fieldKey = field
                        .replace(/[^a-zA-Z0-9]/g, "")
                        .toLowerCase()
                        .replace(/\s+/g, "_");
                      const fieldValue = file?.fields?.[fieldKey] || "";
                      const errorKey = `${currentCategory}-${docIndex}-${fieldKey}`;

                      return (
                        <div key={fieldId} className="dept-field-group">
                          <label htmlFor={fieldId} className="form-label">
                            {field}
                          </label>
                          <input
                            id={fieldId}
                            type={
                              field === "Date the Document was Issued"
                                ? "date"
                                : "text"
                            }
                            max={
                              field === "Date the Document was Issued"
                                ? new Date().toISOString().split("T")[0]
                                : undefined
                            }
                            className={`dept-input ${fieldErrors[errorKey] ? "error" : ""}`}
                            placeholder={field}
                            value={fieldValue}
                            onChange={(e) => {
                              let value = e.target.value;

                              if (field === "Date the Document was Issued") {
                                const parts = value.split("-");
                                if (parts[0] && parts[0].length > 4) {
                                  parts[0] = parts[0].slice(0, 4);
                                  value = parts.join("-");
                                }
                              }

                              handleFieldChange(currentCategory, docIndex, fieldKey, value);
                            }}
                          />
                          {fieldErrors[errorKey] && (
                            <span className="error-text">{fieldErrors[errorKey]}</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))
          ) : (
            textInputs[currentCategory] && (
              <p className="no-file-message">
                No file inputs available for this category
              </p>
            )
          )}
        </div>
        <div className="add-file-button-wrapper">
          {textInputs[currentCategory] &&
            <div
              onClick={() => addFileInput1(currentCategory)}
              style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <img
                src={add}
                width={40}
                alt="Add Document"
                className="add-file-icon"
              />
              <p style={{ margin: 0, marginTop: '8px', cursor: 'pointer' }}>Add Document</p>
            </div>}
        </div>
      </div>
    );
  };
  const onFileChange = (e, currentCategory, index) => {
    const selectedFile = e.target.files[0];
    setDisableButton(true)

    const fieldErrorKey = `${currentCategory}-${index}-file`;

    if (selectedFile && selectedFile.size > MAX_UPLOAD_SIZE_BYTES) {
      const message = `File size should be less than ${MAX_UPLOAD_SIZE_MB}MB.`;
      setFieldErrors((prev) => ({
        ...prev,
        [fieldErrorKey]: message,
      }));
      showFormBackendError(message, message);
      setDisableButton(false);
      e.target.value = "";
      return;
    }

    if (selectedFile) {
      const currentFields = fileInputs1[currentCategory]?.[index]?.fields || {};
      setFieldErrors((prev) => ({ ...prev, [fieldErrorKey]: "" }));
      handleFiles(e, currentCategory, index);
      setTimeout(() => {
        setFileInputs1((prevFileInputs) => {
          const updatedFileInputs = { ...prevFileInputs };
          if (
            updatedFileInputs[currentCategory] &&
            updatedFileInputs[currentCategory][index]
          ) {
            updatedFileInputs[currentCategory][index].fields = currentFields;
          }
          return updatedFileInputs;
        });
      }, 100);
    } else {
      setDisableButton(false);
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const handleSelect = (item, currentCategory) => {
    setShowUploadFiles(item)
    setShowDropdown(false);
    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [currentCategory]: item,
    }));
  };
  const handleClick = (inputRef) => {
    if (inputRef) inputRef.click();
  };

  const setInlineUploadError = (fieldErrorKey, message) => {
    if (!fieldErrorKey) return;

    if (fieldErrorKey.startsWith("Category_")) {
      setFieldErrors((prev) => ({ ...prev, [fieldErrorKey]: message }));
      return;
    }

    if (fieldErrorKey.startsWith("neighbour:")) {
      const direction = fieldErrorKey.split(":")[1];
      setErrors((prev) => ({
        ...prev,
        neighbourDetails: {
          ...(typeof prev.neighbourDetails === "object" ? prev.neighbourDetails : {}),
          [direction]: message,
        },
      }));
      return;
    }

    setErrors((prev) => ({ ...prev, [fieldErrorKey]: message }));
  };

  const uploadKypDocument = async (formDataUpload, fieldErrorKey = "") => {
    const uploadFile = formDataUpload?.get("image");

    if (uploadFile?.size > MAX_UPLOAD_SIZE_BYTES) {
      const sizeError = `File size should be less than ${MAX_UPLOAD_SIZE_MB}MB.`;
      setInlineUploadError(fieldErrorKey, sizeError);
      return null;
    }

    const response = await PropertiesService.UploadFiles(formDataUpload);

    if (!response || typeof response === "string" || !response.Location) {
      const message = getApiErrorMessage(response, "Unable to upload file.");
      setInlineUploadError(fieldErrorKey, message);
      return null;
    }

    setInlineUploadError(fieldErrorKey, "");
    setFormError("");

    return response;
  };

  const handleFiles = async (e, currentCategory, index) => {
    const file = e.target.files[0];
    if (file) {
      const f = new FormData();
      f.append("image", file);

      try {
        setFileInputs1((prevState) => {
          const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
          const entry = { ...(updatedCategoryFiles[index] || {}) };
          entry.loading = true;

          updatedCategoryFiles[index] = entry;
          return { ...prevState, [currentCategory]: updatedCategoryFiles };
        });

        const response = await uploadKypDocument(
          f,
          `${currentCategory}-${index}-file`
        );

        if (!response?.Location) {
          setFileInputs1((prevState) => {
            const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
            const entry = { ...(updatedCategoryFiles[index] || {}) };
            entry.loading = false;
            updatedCategoryFiles[index] = entry;
            return { ...prevState, [currentCategory]: updatedCategoryFiles };
          });
          setDisableButton(false);
          return;
        }

        if (response.Location) {
          setDisableButton(false)
          setFileInputs1((prevState) => {
            const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
            const oldEntry = updatedCategoryFiles[index] || {};

            updatedCategoryFiles[index] = {
              ...oldEntry,
              id: Math.random().toString(36).substr(2, 9),
              name: file.name,
              type: file.type,
              size: file.size,
              file: response.Location,
              loading: false,

            };

            return {
              ...prevState,
              [currentCategory]: updatedCategoryFiles,
            };
          });
        } else {
          setFileInputs1((prevState) => {
            const updatedCategoryFiles = [...(prevState[currentCategory] || [])];
            const entry = { ...(updatedCategoryFiles[index] || {}) };
            entry.loading = false;
            setDisableButton(false)

            updatedCategoryFiles[index] = entry;
            return { ...prevState, [currentCategory]: updatedCategoryFiles };
          });
        }

      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };
  const [search, setSearch] = useState("");
  const [dummyData, setDepartmentList] = useState([]);
  const addCategory = (e) => {
    e.preventDefault();
    const newCategory = `Category_${categories1.length + 1}`;

    setCategories1((prevCategories) => [...prevCategories, newCategory]);

    setFileInputs1((prevFileInputs) => ({
      ...prevFileInputs,
      [newCategory]: [],
    }));

    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [newCategory]: "",
    }));

    setActiveStepper(categories1.length);
  };

  const addFileInput1 = (category) => {
    setFileInputs1((prev) => {
      const updated = [...(prev[category] || [])];
      updated.push({
        id: Math.random().toString(36).substr(2, 9),
        file: null,
        loading: false,
        ref: null,
        fields: {
          typeofdocument: "",
          departmentofregistrationandstamps: "",
          datethedocumentwasissued: "",
          nameofissuingofficer: "",
          designationofofficer: "",
          officesituatedat: "",
        },
      });
      return { ...prev, [category]: updated };
    });
  };

  const removeFileInput1 = (category, index) => {
    setFileInputs1((prevFileInputs) => {
      if (prevFileInputs[category] && prevFileInputs[category].length > 0) {
        const updatedCategoryFiles = [...prevFileInputs[category]];
        updatedCategoryFiles.splice(index, 1);

        return {
          ...prevFileInputs,
          [category]: updatedCategoryFiles,
        };
      }
      return prevFileInputs;
    });
  };
  const handleFieldChange = (category, docIndex, fieldName, value) => {
    setFileInputs1((prevFileInputs) => {
      const updatedFileInputs = { ...prevFileInputs };

      if (
        updatedFileInputs[category] &&
        updatedFileInputs[category][docIndex]
      ) {
        if (!updatedFileInputs[category][docIndex].fields) {
          updatedFileInputs[category][docIndex].fields = {};
        }
        updatedFileInputs[category][docIndex].fields[fieldName] = value;
      }

      return updatedFileInputs;
    });
  };
  const handleTextInputChange = (category, value) => {
    setSearch(value);
    setFilteredOptions(
      dummyData.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      )
    );
    setShowDropdown(true);
    setTextInputs((prevTextInputs) => ({
      ...prevTextInputs,
      [category]: value,
    }));
  };
  const [filteredOptions, setFilteredOptions] = useState(dummyData);
  const handleStepClick = (index, name) => {
    if (index <= activestepper) {
      setActiveStepper(index);
      return;
    }
    const allPreviousStepsCompleted = categories
      .slice(0, index)
      .every((category) => {
        const formattedCategory = formatCategoryName(category);
        return (
          fileInputs[formattedCategory] &&
          fileInputs[formattedCategory].some((input) => input.data)
        );
      });
    setActiveStepper(index);
  };

  const otherList = ["Firm", "Company", "LLP", "Other"];
  const refdisplayAddDocww = useRef(null);
  const [ownerName, setOwnerName] = useState("");
  const [ownerNameError, setOwnerNameError] = useState("");
  const [typeOfProperty, setTypeOfProperty] = useState("");
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [landUseDoc, setLandUseDoc] = useState();
  const architectRef = useRef(null);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails")) || null
  );
  const surveyorRef = useRef(null);
  const landUseref = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [isLoading1, setisLoading1] = useState(false);
  const [isLoading11, setisLoading11] = useState(false);
  /** Per-upload loading — do not share across document types (avoids races with main elevation vs surveyor). */
  const [uploadLoadingMainElevation, setUploadLoadingMainElevation] = useState(false);
  const [uploadLoadingSurveyor, setUploadLoadingSurveyor] = useState(false);
  const [uploadLoadingArchitect, setUploadLoadingArchitect] = useState(false);
  const [isLoading3, setisLoading3] = useState(false);
  const [isLoading4, setisLoading4] = useState(false);
  const [isLoading5, setisLoading5] = useState(false);
  const [isLoading8, setisLoading8] = useState(false);
  const [isLoadingowner, setisLoadingowner] = useState(false);
  const [activeStep, setActiveStep] = useState("step1");
  const [formError, setFormError] = useState("");
  const showFormBackendError = (error, fallbackMessage = "Something went wrong") => {
    const message = getApiErrorMessage(error, fallbackMessage);
    setFormError(message);
    setTimeout(() => setFormError(""), 5000);
  };
  const [isLoadingOtherSideB, setIsLoadingOtherSideB] = useState(false);
  const neighbourRef = useRef(null);
  const uploadRefs = useRef({});
  /** Per-direction neighbour doc upload loading (do not reuse ownerPhoto `isLoading`). */
  const [neighbourDirectionLoading, setNeighbourDirectionLoading] = useState({});
  /** Monotonic version per direction — ignore stale upload completions (out-of-order responses). */
  const neighbourUploadVersionRef = useRef({});
  const removeCategory = (categoryToRemove) => {
    const categoryIndex = categories1.indexOf(categoryToRemove);
    const newCategories = categories1.filter(
      (category) => category !== categoryToRemove
    );
    setCategories1(newCategories);
    const newFileInputs = { ...fileInputs1 };
    delete newFileInputs[categoryToRemove];
    setFileInputs1(newFileInputs);
    const newTextInputs = { ...textInputs };
    delete newTextInputs[categoryToRemove];
    setTextInputs(newTextInputs);
    let newActiveIndex;
    if (newCategories.length === 0) {
      newActiveIndex = 0;
    } else if (categoryIndex > 0) {
      newActiveIndex = categoryIndex - 1;
    } else {
      newActiveIndex = 0;
    }
    setActiveStepper(newActiveIndex);
  };
  const [paymentStatus, setPaymentStatus] = useState(false);

  const futureOwnershipRef = useRef(null);
  const [firmType, setFirmType] = useState("");
  const [otherFirmDetail, setOtherFirmDetail] = useState("");
  const [buildingAge, setBuildingAge] = useState("");
  const [buildingDescription, setBuildingDescription] = useState("");
  const [architectDetails, setArchitectDetails] = useState("");
  const [civilEngineerDetails, setCivilEngineerDetails] = useState("");
  const [ownerPhoto, setOwnerPhoto] = useState(null);
  const [mainElevation, setMainElevation] = useState(null);
  const [otherSideA, setOtherSideA] = useState(null);
  const [otherSideB, setOtherSideB] = useState(null);
  const [otherSideC, setOtherSideC] = useState(null);
  const [hasError, setHasError] = useState(false);
  const ownerPhotoRef = useRef(null);
  const mainElevationRef = useRef(null);
  const otherSideARef = useRef(null);
  const otherSideBRef = useRef(null);
  const otherSideCRef = useRef(null);
  const [amsl, setAmsl] = useState("");
  const [roadDetails, setRoadDetails] = useState("");
  const [sro, setSro] = useState("");
  const [pd, setPd] = useState("");
  const [drawings, setDrawings] = useState(null);
  const [legalStatus, setLegalStatus] = useState("");
  const [financialStatus, setFinancialStatus] = useState("");
  const [token, setToken] = useState("");
  const [completedSteps, setCompletedSteps] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [customDepartment, setCustomDepartment] = useState("");
  const [documents, setDocuments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [architectNote, setArchitectNote] = useState("");
  const [editNote, setEditNote] = useState("");
  const [surveyorNote, setSurveyorNote] = useState("");
  const [editSurveyorNote, setEditSurveyorNote] = useState("");
  const [editingSurveyorIndex, setEditingSurveyorIndex] = useState(null);
  const [editingLandUseIndex, setEditingLandUseIndex] = useState(null);
  const [landUseNote, setLandUseNote] = useState("");
  const [editingLandUse, setEditingLandUse] = useState(false);
  const [editingLandUseNote, setEditingLandUseNote] = useState(false);
  const [editLandUseNote, setEditLandUseNote] = useState("");
  const [futureOwnershipNote, setFutureOwnershipNote] = useState("");
  const [editingFutureOwnership, setEditingFutureOwnership] = useState(false);
  const [editingFutureOwnershipNote, setEditingFutureOwnershipNote] = useState(false);
  const [editFutureOwnershipNote, setEditFutureOwnershipNote] = useState("");
  const [drawingNote, setDrawingNote] = useState("");
  const [editingDrawing, setEditingDrawing] = useState(false);
  const [editingDrawingNote, setEditingDrawingNote] = useState(false);
  const [editDrawingNote, setEditDrawingNote] = useState("");
  const [ownerPhotoNote, setOwnerPhotoNote] = useState("");
  const [editingOwnerPhoto, setEditingOwnerPhoto] = useState(false);
  const [editingOwnerPhotoNote, setEditingOwnerPhotoNote] = useState(false);
  const [editOwnerPhotoNote, setEditOwnerPhotoNote] = useState("");
  const [editMainElevationNote, setEditMainElevationNote] = useState(false);
  const [mainElevationNote, setMainElevationNote] = useState("");
  const [editingMainElevation, setEditingMainElevation] = useState(false);
  const [editingMainElevationNote, setEditingMainElevationNote] = useState(false);
  const [otherSideBNote, setOtherSideBNote] = useState("");
  const [editingOtherSideB, setEditingOtherSideB] = useState(false);
  const [editingOtherSideBNote, setEditingOtherSideBNote] = useState(false);
  const [editOtherSideBNote, setEditOtherSideBNote] = useState("");
  const [otherSideANote, setOtherSideANote] = useState("");
  const [editingOtherSideA, setEditingOtherSideA] = useState(false);
  const [editingOtherSideANote, setEditingOtherSideANote] = useState(false);
  const [editOtherSideANote, setEditOtherSideANote] = useState("");
  const [editingOtherSideCNote, setEditingOtherSideCNote] = useState(false);
  const [editOtherSideCNote, setEditOtherSideCNote] = useState("");
  const [otherSideCNote, setOtherSideCNote] = useState("");
  const [isLoadingOtherSideC, setIsLoadingOtherSideC] = useState(false);
  const [editingOtherSideC, setEditingOtherSideC] = useState(false);
  const [tempNote, setTempNote] = useState({});
  const [editingNote, setEditingNote] = useState({});
  const [editedNotes, setEditedNotes] = useState({});
  const [editingSurveyorNoteIndex, setEditingSurveyorNoteIndex] =
    useState(null);
  const [replacingSurveyorDocIndex, setReplacingSurveyorDocIndex] =
    useState(null);
  const [editingNoteIndex, setEditingNoteIndex] = useState(null);
  const [replacingDocIndex, setReplacingDocIndex] = useState(null);
  const [PropertyResponse, setPropertyResponse] = useState([]);
  const [noteInput, setNoteInput] = useState("");
  const [errors, setErrors] = useState({});
  const [RazorPayShow, setRazorPayShow] = useState(false);
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    setToken(localStorage.getItem("token") || "");
    setUserDetails(userDetails);

    if (userDetails?.user_id) {
      setFormData((prev) => ({
        ...prev,
        userId: userDetails.user_id,
      }));
    }
  }, []);

  const [departments, setDepartments] = useState([]);
  const getAllDepartmentsList = async () => {
    const response = await PropertiesService.getAllDepartments();
    console.log(response, 'responsessss')
    if (response.message === "Success") {
      const filter = response.data.map((x) => x.name);
      setDepartmentList(filter);
    }
  };
  const [formData, setFormData] = useState({
    userId: userDetails?.user_id || "",
    filledBy: "",
    otherPersonDetails: {
      name: "",
      dob: "",
      age: "",
      email: "",
      address: ""
    },
    typeOfProperty: "",
    ownerName: "",
    aadhar: "",
    selectedPropertyType: "",
    location: "",
    Department_wise_Documents: [],
    ownedSince: "",
    taxDetails: "",
    marketValue: "",
    selfDeclaration: false,
    selfDeclaration2: false,
    selfDeclaration3: false,
    googleLocation: "",
    postalCode: "",
    constructionDetails: "",
    architectDoc: [],
    surveyorDoc: [],
    landUseDoc: [],
    neighbourDetails: [
      {
        direction: "eastern",
        name: "",
        document: [],
      },
      {
        direction: "western",
        name: "",
        document: [],
      },
      {
        direction: "northern",
        name: "",
        document: [],
      },
      {
        direction: "southern",
        name: "",
        document: [],
      },
    ],

    futureOwnershipDoc: [],
    email: "",
    mobile: "",
    nomineeDetail: "",
    ownershipCertificateDeclaration: false,
    marketPlanLandUseChoice: "",
    noMasterPlanDeclaration: false,
    noMasterPlanPropertyType: "",
    bankLoanChoice: "",
    titlePossessionConsent: false,
    consentSharing: false,
    consentSurvey: false,
    futureTitleGuarantee: false,
    internationalGovernance: false,
    amsl: "",
    roadDetails: "",
    sro: "",
    pd: "",
    drawings: null,
    legalStatus: "",
    financialStatus: "",
    firmType: "",
    otherFirmDetail: "",
    ownerPhoto: [],
    mainElevation: [],
    otherSideA: [],
    otherSideB: [],
    otherSideC: [],
    buildingAge: "",
    buildingDescription: "",
    architectDetails: "",
    civilEngineerDetails: "",
    consultants: [],
    contractors: [],
  });
  const handleOtherSideAUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setisLoading3(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "otherSideA");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        otherSideA: {
          url: fileUrl,
          note: editingOtherSideA
            ? prev.otherSideA?.note || ""
            : otherSideANote.trim(),
        },
      }));

      setOtherSideANote("");
      setEditingOtherSideA(false);
    } catch (error) {
      console.error("❌ Error uploading Other Side A:", error);
    } finally {
      setisLoading3(false);
    }
  };
  const handleOtherSideADelete = () => {
    setFormData((prev) => ({ ...prev, otherSideA: null }));
    setOtherSideANote("");
    setEditingOtherSideA(false);
    setEditingOtherSideANote(false);
    setEditOtherSideANote("");
  };
  const startEditingOtherSideANote = () => {
    setEditingOtherSideANote(true);
    setEditOtherSideANote(formData.otherSideA?.note || "");
  };

  const saveEditedOtherSideANote = () => {
    setFormData((prev) => ({
      ...prev,
      otherSideA: {
        ...prev.otherSideA,
        note: editOtherSideANote.trim(),
      },
    }));
    setEditingOtherSideANote(false);
    setEditOtherSideANote("");
  };
  const handleMobileChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, mobile: value });

    if (!value) {
      setErrors({ ...errors, mobile: "Phone number is required" });
    } else if (value.length !== 10) {
      setErrors({ ...errors, mobile: "Phone number should be 10 digits" });
    } else {
      setErrors({ ...errors, mobile: "" });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};


    if (!formData.ownerPhoto || !formData.ownerPhoto.url)
      newErrors.ownerPhoto = "Owner Photo is required";
    if (!formData.firmType) newErrors.firmType = "Firm Type is required";
    if (!formData.mainElevation || !formData.mainElevation.url)
      newErrors.mainElevation = "Main Elevation is required";
    if (!formData.otherSideA || !formData.otherSideA.url)
      newErrors.otherSideA = "Other Side A is required";
    if (!formData.otherSideB || !formData.otherSideB.url)
      newErrors.otherSideB = "Other Side B is required";
    if (!formData.otherSideC || !formData.otherSideC.url)
      newErrors.otherSideC = "Other Side C is required";
    if (!formData.buildingAge)
      newErrors.buildingAge = "Building Age is required";
    if (!formData.buildingDescription)
      newErrors.buildingDescription = "Building Description is required";
    if (!formData.architectDetails)
      newErrors.architectDetails = "Architect Details are required";
    if (!formData.civilEngineerDetails)
      newErrors.civilEngineerDetails = "Civil Engineer Details are required";

    if (!formData.filledBy) {
      newErrors.filledBy = "Please select who has filled out this form";
    }
    if (formData.filledBy === "other") {
      if (!formData.otherPersonDetails.dob)
        newErrors.otherPersonDob = "Date of Birth is required";
      else if (formData.otherPersonDetails.dob > maxDobDate)
        newErrors.otherPersonDob = "Date of Birth cannot be in the future";
      if (!formData.otherPersonDetails.age)
        newErrors.otherPersonAge = "Age is required";
      if (!formData.otherPersonDetails.email)
        newErrors.otherPersonEmail = "Email is required";
      if (!formData.otherPersonDetails.address)
        newErrors.otherPersonAddress = "Address is required";
    }
    // if (!formData.consultants)
    //   newErrors.consultants = "Consultants are required";
    if (!formData.consultants) {
      newErrors.consultants = "Consultants are required";
    } else if (
      typeof formData.consultants === "string" &&
      formData.consultants.startsWith("Other:") &&
      formData.consultants.substring(6).trim() === ""
    ) {
      newErrors.consultants = "Please specify the other consultant";
    }

    // if (!formData.contractors)
    //   newErrors.contractors = "Contractors are required";
    if (!formData.contractors) {
      newErrors.contractors = "Contractors are required";
    } else if (
      typeof formData.contractors === "string" &&
      formData.contractors.startsWith("Other:") &&
      formData.contractors.substring(6).trim() === ""
    ) {
      newErrors.contractors = "Please specify the other Contractor";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        setErrors({});
      }, 3000);
      return;
    } else {
      setErrors({});
    }

    setLoader(true);
    const documents = {
      categories: categories1,
      files: sanitizeFileInputs(fileInputs1),
      descriptions: textInputs,
    };

    const filterFilledKYPS = await getActiveKypDrafts();

    // ✅ Check if we are editing an existing KYP or continuing a draft
    if (editKypId || filterFilledKYPS.length > 0) {
      const updateKypObject = {
        ...formData,
        aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
        amsl: parseFloat(formData.amsl) || formData.amsl,
        marketValue: parseFloat(formData.marketValue) || formData.marketValue,
        buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
        postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
        ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
        mobile: parseInt(formData.mobile, 10) || formData.mobile,
        taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
        selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
        Department_wise_Documents: documents,

        // ✅ Use editKypId if we are editing, otherwise fallback to the draft ID
        KypId: editKypId || filterFilledKYPS[0]?._id,

        consultantType: consultantType,
        contractorType: contractorType,
        marketPlanLandUseChoiceValue: formData.marketPlanLandUseChoice || "",
        marketPlanLandUseChoice: MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
        noMasterPlanDeclaration: formData.noMasterPlanDeclaration ? NO_MASTER_PLAN_DECLARATION_LABEL : "",
        noMasterPlanPropertyTypeValue: formData.noMasterPlanPropertyType || "",
        noMasterPlanPropertyType: NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
        bankLoanChoiceValue: formData.bankLoanChoice || "",
        bankLoanChoice: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
        ownershipCertificateDeclaration: formData.ownershipCertificateDeclaration ? OWNERSHIP_DECLARATION_LABEL : "",
        titlePossessionConsent: formData.titlePossessionConsent ? TITLE_POSSESSION_CONSENT_LABEL : "",
        noMasterPlanDeclarationBoolean: !!formData.noMasterPlanDeclaration,
        ownershipCertificateDeclarationBoolean: !!formData.ownershipCertificateDeclaration,
        titlePossessionConsentBoolean: !!formData.titlePossessionConsent,
        noMasterPlanDeclarationText: formData.noMasterPlanDeclaration ? NO_MASTER_PLAN_DECLARATION_LABEL : "",
        noMasterPlanPropertyTypeText: NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
        ownershipCertificateDeclarationText: formData.ownershipCertificateDeclaration ? OWNERSHIP_DECLARATION_LABEL : "",
        marketPlanLandUseChoiceText: MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
        bankLoanChoiceText: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
        titlePossessionConsentText: formData.titlePossessionConsent ? TITLE_POSSESSION_CONSENT_LABEL : "",
      };

      try {
        const response = await PropertiesService.editkyp(updateKypObject);
        setLoader(false);
        setPropertyResponse(response.data);

        // ✅ If it's an edit, close the modal and skip the payment flow entirely
        if (editKypId) {
          toast.success("Property updated successfully!");
          if (closeModal) closeModal();
          localStorage.setItem('kypedit', 'kypedit')
        } else {
          // ✅ Otherwise show the payment modal for new submissions
          setpaymentStatusModel(true);
        }

      } catch (error) {
        setLoader(false);
        console.error("❌ Error:", error.message);
        alert(`Failed to submit form: ${error.message}`);
      }
    } else {
      // ✅ Create a brand new KYP
      const jsonData = {
        ...formData,
        // ... (Keep your existing mapping logic here for creating a new KYP)
      };

      try {
        const response = await PropertiesService.KnowYourProperty(jsonData);
        setPropertyResponse(response.data);
        setpaymentStatusModel(true);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error("❌ Error:", error.message);
        alert(`Failed to submit form: ${error.message}`);
      }
    }
  };

  const [consultantType, setconsultantType] = useState(formData.consultantType);
  const [contractorType, setcontractorType] = useState(formData.contractorType);
  const onLoad = () => {
    setisLoading(false);
    setHasError(false);
  };
  const onLoad2 = () => {
    setisLoading(false);
    setHasError(false);
  };
  const onLoad3 = () => {
    setisLoading(false);
    setHasError(false);
  };
  const onError = () => {
    setisLoading(false);
    setHasError(true);
  };
  const handleFileUpload = async (event, name) => {
    const file = event.target.files[0];
    const formDataData = new FormData();
    formDataData.append("image", file);

    try {
      // Set loader
      if (name === "ownerPhoto") setisLoading(true);
      else if (name === "mainElevation") setUploadLoadingMainElevation(true);
      else if (name === "otherSideA") setisLoading3(true);
      else if (name === "otherSideB") setisLoading4(true);
      else if (name === "otherSideC") setisLoading5(true);

      const response = await uploadKypDocument(formDataData, name);
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        [name]: fileUrl,
        notes: {
          ...prev.notes,
          [name]: prev.notes?.[name] || "",
        },
      }));
      if (name === "ownerPhoto") setOwnerPhoto(fileUrl);
      else if (name === "mainElevation") setMainElevation(fileUrl);
      else if (name === "otherSideA") setOtherSideA(fileUrl);
      else if (name === "otherSideB") setOtherSideB(fileUrl);
      else if (name === "otherSideC") setOtherSideC(fileUrl);
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      if (name === "ownerPhoto") setisLoading(false);
      else if (name === "mainElevation") setUploadLoadingMainElevation(false);
      else if (name === "otherSideA") setisLoading3(false);
      else if (name === "otherSideB") setisLoading4(false);
      else if (name === "otherSideC") setisLoading5(false);
    }
  };
  const handleMainElevationUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploadLoadingMainElevation(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "mainElevation");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        mainElevation: {
          url: fileUrl,
          note: editingMainElevation
            ? prev.mainElevation?.note || ""
            : mainElevationNote.trim(),
        },
      }));

      setMainElevationNote("");
      setEditingMainElevation(false);
    } catch (error) {
      console.error("❌ Error uploading mainElevation:", error);
    } finally {
      setUploadLoadingMainElevation(false);
    }
  };
  const handleMainElevationDelete = () => {
    setFormData((prev) => ({ ...prev, mainElevation: null }));
    setMainElevationNote("");
    setEditingMainElevation(false);
    setEditingMainElevationNote(false);
    setEditMainElevationNote("");
  };
  const startEditingMainElevationNote = () => {
    setEditingMainElevationNote(true);
    setEditMainElevationNote(formData.mainElevation?.note || "");
  };
  const saveEditedMainElevationNote = () => {
    setFormData((prev) => ({
      ...prev,
      mainElevation: {
        ...prev.mainElevation,
        note: editMainElevationNote.trim(),
      },
    }));
    setEditingMainElevationNote(false);
    setEditMainElevationNote("");
  };
  const handleFileUpload12 = async (event, name) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setisLoading(true);
    try {
      const response = await uploadKypDocument(formData, name);
      if (!response?.Location) return;

      switch (name) {
        case "ownerPhoto":
          setOwnerPhoto(response.Location);
          break;
        case "mainElevation":
          setMainElevation(response.Location);
          break;
        case "otherSideA":
          setOtherSideA(response.Location);
          break;
        case "otherSideB":
          setOtherSideB(response.Location);
          break;
        case "otherSideC":
          setOtherSideC(response.Location);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("❌ Error uploading file:", error);
    } finally {
      setisLoading(false);
    }
  };
  const handleOwnerName = (e) => {
    const value = e.target.value.replace(/\s+/g, " ");

    setOwnerName(value);
    setFormData((prev) => ({ ...prev, ownerName: value }));
    if (!value) {
      setOwnerNameError("Property Owner Name is required");
    } else {
      setOwnerNameError("");
    }
  };
  const handleTypeProperty = (e) => {
    const value = e.target.value;
    setTypeOfProperty(value);
    setFormData((prev) => ({ ...prev, typeOfProperty: value }));
  };
  const handlePropertyType = (e) => {
    const value = e.target.value;
    setSelectedPropertyType(value);
    setFormData((prev) => ({ ...prev, selectedPropertyType: value }));
  };
  const [editingIndex, setEditingIndex] = useState(null);
  const handleFileUpload1 = async (event, name) => {
    const file = event.target.files[0];

    if (!file) {
      console.error("❌ No file selected!");
      return;
    }
    const f = new FormData();
    f.append("image", file);
    for (let pair of f.entries()) {
    }

    setisLoading3(true);

    try {
      const response = await uploadKypDocument(f, "landUseDoc");

      if (!response || !response.Location) {
        throw new Error("❌ Invalid response from the server");
      }

      setFormData((prev) => ({
        ...prev,
        landUseDoc: response.Location,
      }));
      setLandUseDoc(response.Location);
    } catch (error) {
      console.error("❌ Error uploading document:", error);
    } finally {
      setisLoading3(false);
    }
  };
  const handleOtherSideCUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setisLoading5(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "otherSideC");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        otherSideC: {
          url: fileUrl,
          note: editingOtherSideC
            ? prev.otherSideC?.note || ""
            : otherSideCNote.trim(),
        },
      }));

      setOtherSideCNote("");
      setEditingOtherSideC(false);
    } catch (error) {
      console.error("❌ Error uploading Other Side C:", error);
    } finally {
      setisLoading5(false);
    }
  };
  const handleDeleteOtherSideC = () => {
    setFormData((prev) => ({
      ...prev,
      otherSideC: null,
    }));
    setOtherSideCNote("");
    setEditingOtherSideC(false);
    setEditingOtherSideCNote(false);
    setEditOtherSideCNote("");
  };
  const initialState = categories.reduce((acc, category) => {
    acc[formatCategoryName(category)] = [{ id: "input-1", data: null }];
    return acc;
  }, {});
  const [fileInputs, setFileInputs] = useState(initialState);
  const handleArchitectUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const f = new FormData();
    f.append("image", file);
    setUploadLoadingArchitect(true);

    try {
      const response = await uploadKypDocument(f, "architectDoc");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      const replaceIndex = replacingDocIndex;
      const noteSnapshot = architectNote?.trim() || "";

      if (replaceIndex !== null) {
        setFormData((prev) => {
          const updatedDocs = [...(prev.architectDoc || [])];
          if (!updatedDocs[replaceIndex]) {
            return prev;
          }
          updatedDocs[replaceIndex] = {
            ...updatedDocs[replaceIndex],
            url: fileUrl,
            note: updatedDocs[replaceIndex].note,
          };
          return { ...prev, architectDoc: updatedDocs };
        });
        setReplacingDocIndex(null);
      } else {
        setFormData((prev) => ({
          ...prev,
          architectDoc: [
            ...(prev.architectDoc || []),
            {
              url: fileUrl,
              note: noteSnapshot,
            },
          ],
        }));
      }

      setArchitectNote("");
    } catch (error) {
      console.error("❌ Error uploading Architect document:", error);
    } finally {
      setUploadLoadingArchitect(false);
      if (event?.target) event.target.value = "";
    }
  };
  const handleArchitectDelete = (index) => {
    if (architectRef.current) {
      architectRef.current.value = null; // Reset file input
    }
    const updatedDocs = [...formData.architectDoc];
    updatedDocs.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      architectDoc: updatedDocs,
    }));

    if (editingIndex === index) {
      setEditingIndex(null);
      setEditNote("");
    }
  };
  const handleMakePayment = async () => {
    setpaymentDone(true);
  };
  const handleCancelPayment = () => {
    navigate("/KYPList");
  };
  const RouteToProperties = () => {
    navigate("/KYPList");
  };
  const handleClose = () => {
    setpaymentStatusModel(false);
    setAadhaarNumber("");
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setIsAadhaarVerified(false);
    setIsSendingAadhaarOtp(false);
    setIsVerifyingAadhaarOtp(false);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
    setShowAadhaarOtpModal(false);
  };

  const OWNERSHIP_DECLARATION_LABEL = "I hereby solemnly declare that all the information provided by me in respect of the property submitted is true, accurate, and complete to the best of my knowledge and belief.";
  const MARKET_PLAN_LANDUSE_LABELS = {
    applied: "I have applied with department",
    upload60Days: "I will upload in 75 days for my property",
  };
  const BANK_LOAN_LABELS = {
    interested: "I am interested in bank loan in near future",
    sanctioned: "I already have a sanction loan on the property",
  };
  const NO_MASTER_PLAN_DECLARATION_LABEL =
    "There is no existing master plan and it is not available with concerned MA & UD / Local Town Planning Department";
  const NO_MASTER_PLAN_PROPERTY_TYPE_LABELS = {
    residential: "Residential",
    commercial: "Commercial",
    institutional: "Institutional",
    industrial: "Industrial",
    agricultureFarmHouse: "Agriculture (Farm House)",
    anyOther: "Any other than not mentioned",
  };
  const TITLE_POSSESSION_CONSENT_LABEL =
    "In the future I give my consent to doCity to share my property details with banks and insurance companies and other government departments for the safety of the property";

  const getLookupKeyByValue = (lookupObject, value) => {
    if (!value) return "";
    const normalizedValue = String(value).trim().toLowerCase();

    return (
      Object.entries(lookupObject).find(([key, label]) => {
        return (
          key === value ||
          String(label).trim().toLowerCase() === normalizedValue
        );
      })?.[0] || ""
    );
  };

  const ownershipCertificateAddress =
    formData?.googleLocation ||
    [formData?.location, formData?.pd, formData?.sro, formData?.postalCode]
      .filter(Boolean)
      .join(", ") ||
    "Address will be populated from your property details.";

  const ownershipCertificateStatement =
    "I acknowledge my application to DoCity Civil Engineers Private Limited. I self declare I am the owner of this property with my registration details, municipal and survey details.";

  const isNoMasterPlanSelectionValid =
    !!formData?.noMasterPlanDeclaration && !!formData?.noMasterPlanPropertyType;
  const isMarketPlanSelectionValid =
    !!formData?.marketPlanLandUseChoice || isNoMasterPlanSelectionValid;

  const isKypPayLaterEnabled =
    !!formData?.ownershipCertificateDeclaration &&
    isMarketPlanSelectionValid &&
    !!formData?.bankLoanChoice &&
    !!formData?.titlePossessionConsent &&
    isAadhaarVerified;

  const handleAadhaarNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 12);
    setAadhaarNumber(digits);
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setShowAadhaarOtpModal(false);
    setIsAadhaarVerified(false);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
  };

  const handleAadhaarOtpChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
    setAadhaarOtp(digits);
    setAadhaarError("");
  };

  const handleSendAadhaarOtp = async () => {
    if (isSendingAadhaarOtp) return;
    if (aadhaarNumber.length !== 12) {
      setAadhaarError("Aadhaar number must be 12 digits.");
      return;
    }
    // Temporarily bypass OTP integration; enable direct verify until subscription is finalized.
    setAadhaarError("");
    setAadhaarOtp("");
    setAadhaarReferenceId("");
    setShowAadhaarOtpModal(false);
    setIsAadhaarVerified(true);
    setAadhaarSuccessMessage("Aadhaar verified successfully.");
    toast.success("Aadhaar verified successfully.");
  };

  const handleVerifyAadhaarOtp = async () => {
    if (isVerifyingAadhaarOtp) return;
    if (!aadhaarReferenceId) {
      setAadhaarError("Please send OTP first.");
      return;
    }
    if (aadhaarOtp.length !== 6) {
      setAadhaarError("OTP must be 6 digits.");
      return;
    }

    setIsVerifyingAadhaarOtp(true);
    setAadhaarError("");
    setAadhaarSuccessMessage("");
    try {
      const response = await requestsService.validateAadharOtp({
        reference_id: String(aadhaarReferenceId),
        otp: aadhaarOtp,
      });
      if (typeof response === "string") throw new Error(response);
      const message = response?.data?.message || response?.message || "";
      const isVerified =
        response?.code === 200 || /verified|success/i.test(String(message || ""));
      if (!isVerified || /invalid/i.test(String(message || ""))) {
        throw new Error(message || "Invalid OTP");
      }
      setIsAadhaarVerified(true);
      setAadhaarSuccessMessage("Aadhaar verified successfully.");
      setShowAadhaarOtpModal(false);
      toast.success("Aadhaar verified successfully.");
    } catch (error) {
      const message = getApiErrorMessage(error, "Failed to verify Aadhaar OTP");
      setIsAadhaarVerified(false);
      setAadhaarError(message);
      toast.error(message);
    } finally {
      setIsVerifyingAadhaarOtp(false);
    }
  };

  const handlePayLaterKyp = async () => {
    if (isPayLaterLoadingKyp) return;
    if (!isAadhaarVerified) {
      setAadhaarError("Please verify Aadhaar before proceeding.");
      toast.error("Please verify Aadhaar before proceeding.");
      return;
    }
    if (!isKypPayLaterEnabled) {
      toast.error("Complete the required selections to enable Pay Later");
      return;
    }
    setIsPayLaterLoadingKyp(true);
    try {
      const kypId = PropertyResponse?._id || PropertyResponse?.KypId;
      const normalizedKypId = String(kypId || "");

      if (!normalizedKypId) {
        toast.error("KYP not found to update payment status");
        return;
      }

      const currentUserId = PropertyResponse?.userId || userDetails?.user_id;
      const kypListResponse = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
      const latestKyp = kypListResponse?.data?.find(
        (item) => String(item?._id) === normalizedKypId
      );

      const payLaterPayload = {
        ...(latestKyp || PropertyResponse),
        KypId: normalizedKypId,
        _id: normalizedKypId,
        userId: currentUserId,
        Payment_Status: true,
        paymentStatus: "Paid",
        PaymentStatus: "Paid",
        isFilled: true,
        marketPlanLandUseChoiceValue: formData.marketPlanLandUseChoice || "",
        marketPlanLandUseChoice:
          MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
        noMasterPlanDeclaration: formData.noMasterPlanDeclaration
          ? NO_MASTER_PLAN_DECLARATION_LABEL
          : "",
        noMasterPlanPropertyTypeValue: formData.noMasterPlanPropertyType || "",
        noMasterPlanPropertyType:
          NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
        bankLoanChoiceValue: formData.bankLoanChoice || "",
        bankLoanChoice: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
        ownershipCertificateDeclaration: formData.ownershipCertificateDeclaration
          ? OWNERSHIP_DECLARATION_LABEL
          : "",
        titlePossessionConsent: formData.titlePossessionConsent
          ? TITLE_POSSESSION_CONSENT_LABEL
          : "",
        noMasterPlanDeclarationBoolean: !!formData.noMasterPlanDeclaration,
        ownershipCertificateDeclarationBoolean:
          !!formData.ownershipCertificateDeclaration,
        titlePossessionConsentBoolean: !!formData.titlePossessionConsent,
        noMasterPlanDeclarationText: formData.noMasterPlanDeclaration
          ? NO_MASTER_PLAN_DECLARATION_LABEL
          : "",
        noMasterPlanPropertyTypeText:
          NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
        ownershipCertificateDeclarationText: formData.ownershipCertificateDeclaration
          ? OWNERSHIP_DECLARATION_LABEL
          : "",
        marketPlanLandUseChoiceText:
          MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
        bankLoanChoiceText: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
        titlePossessionConsentText: formData.titlePossessionConsent
          ? TITLE_POSSESSION_CONSENT_LABEL
          : "",
      };

      let updateResponse = await PropertiesService.editkyp(payLaterPayload);

      const refreshAfterUpdate = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
      const updatedFromServer = refreshAfterUpdate?.data?.find(
        (item) => String(item?._id) === normalizedKypId
      );

      const paidOnServer =
        updatedFromServer?.Payment_Status === true ||
        String(updatedFromServer?.paymentStatus || "").toLowerCase() === "paid";

      if (!paidOnServer) {
        const retryPayload = {
          ...(updatedFromServer || latestKyp || PropertyResponse),
          KypId: normalizedKypId,
          _id: normalizedKypId,
          userId: currentUserId,
          Payment_Status: true,
          paymentStatus: "Paid",
          PaymentStatus: "Paid",
          isFilled: true,
          marketPlanLandUseChoiceValue: formData.marketPlanLandUseChoice || "",
          marketPlanLandUseChoice:
            MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
          noMasterPlanDeclaration: formData.noMasterPlanDeclaration
            ? NO_MASTER_PLAN_DECLARATION_LABEL
            : "",
          noMasterPlanPropertyTypeValue: formData.noMasterPlanPropertyType || "",
          noMasterPlanPropertyType:
            NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
          bankLoanChoiceValue: formData.bankLoanChoice || "",
          bankLoanChoice: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
          ownershipCertificateDeclaration: formData.ownershipCertificateDeclaration
            ? OWNERSHIP_DECLARATION_LABEL
            : "",
          titlePossessionConsent: formData.titlePossessionConsent
            ? TITLE_POSSESSION_CONSENT_LABEL
            : "",
          noMasterPlanDeclarationBoolean: !!formData.noMasterPlanDeclaration,
          ownershipCertificateDeclarationBoolean:
            !!formData.ownershipCertificateDeclaration,
          titlePossessionConsentBoolean: !!formData.titlePossessionConsent,
          noMasterPlanDeclarationText: formData.noMasterPlanDeclaration
            ? NO_MASTER_PLAN_DECLARATION_LABEL
            : "",
          noMasterPlanPropertyTypeText:
            NO_MASTER_PLAN_PROPERTY_TYPE_LABELS[formData.noMasterPlanPropertyType] || "",
          ownershipCertificateDeclarationText: formData.ownershipCertificateDeclaration
            ? OWNERSHIP_DECLARATION_LABEL
            : "",
          marketPlanLandUseChoiceText:
            MARKET_PLAN_LANDUSE_LABELS[formData.marketPlanLandUseChoice] || "",
          bankLoanChoiceText: BANK_LOAN_LABELS[formData.bankLoanChoice] || "",
          titlePossessionConsentText: formData.titlePossessionConsent
            ? TITLE_POSSESSION_CONSENT_LABEL
            : "",
        };
        updateResponse = await PropertiesService.editkyp(retryPayload);
      }

      if (updateResponse?.message === "Success") {
        const updatedKyp = updateResponse?.data || {
          ...PropertyResponse,
          Payment_Status: true,
          paymentStatus: "Paid",
          PaymentStatus: "Paid",
          isFilled: true,
        };

        setPropertyResponse(updatedKyp);
        setpaymentDone(true);
        setpaymentStatusModel(false);

        toast.success("Marked as paid. Redirecting to KYP list...");
        navigate("/KYPList", { replace: true });
      } else {
        toast.error(updateResponse || "Unable to mark KYP payment as paid");
      }
    } catch (error) {
      toast.error("Unable to mark KYP payment as paid");
    } finally {
      setIsPayLaterLoadingKyp(false);
    }
  };
  const startEditingNote = (index) => {
    setEditingNoteIndex(index);
    setEditNote(formData.architectDoc[index].note);
  };
  const saveEditedNote = (index) => {
    const updatedDocs = [...formData.architectDoc];
    updatedDocs[index] = {
      ...updatedDocs[index],
      note: editNote,
    };

    setFormData((prev) => ({
      ...prev,
      architectDoc: updatedDocs,
    }));

    setEditingNoteIndex(null);
    setEditNote("");
  };
  const replaceDocument = (index) => {
    setReplacingDocIndex(index);
    architectRef.current.click();
  };
  const handleSurveyorUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const f = new FormData();
    f.append("image", file);
    setUploadLoadingSurveyor(true);

    try {
      const response = await uploadKypDocument(f, "surveyorDoc");
      if (!response?.Location) return;
      const fileUrl = response.Location;
      const replaceIndex = replacingSurveyorDocIndex;
      const noteSnapshot = surveyorNote?.trim() || "";

      if (replaceIndex !== null) {
        setFormData((prev) => {
          const updatedDocs = [...(prev.surveyorDoc || [])];
          if (!updatedDocs[replaceIndex]) {
            return prev;
          }
          updatedDocs[replaceIndex] = {
            ...updatedDocs[replaceIndex],
            url: fileUrl,
            note:
              noteSnapshot ||
              updatedDocs[replaceIndex].note ||
              "",
          };
          return { ...prev, surveyorDoc: updatedDocs };
        });
        setReplacingSurveyorDocIndex(null);
      } else {
        setFormData((prev) => ({
          ...prev,
          surveyorDoc: [
            ...(prev.surveyorDoc || []),
            {
              url: fileUrl,
              note: noteSnapshot,
            },
          ],
        }));
      }

      setSurveyorNote("");
    } catch (error) {
      console.error("❌ Error uploading Surveyor document:", error);
    } finally {
      setUploadLoadingSurveyor(false);
      if (event?.target) event.target.value = "";
    }
  };
  const handleSurveyorDelete = (index) => {
    if (surveyorRef.current) {
      surveyorRef.current.value = null; // Reset file input
    }
    const updatedDocs = [...formData.surveyorDoc];
    updatedDocs.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      surveyorDoc: updatedDocs,
    }));
    if (editingSurveyorIndex === index) {
      setEditingSurveyorIndex(null);
      setEditSurveyorNote("");
    }
  };
  const replaceSurveyorDocument = (index) => {
    setReplacingSurveyorDocIndex(index);
    surveyorRef.current.click();
  };
  const startEditingSurveyorNote = (index) => {
    setEditingSurveyorNoteIndex(index);
    setEditSurveyorNote(formData.surveyorDoc[index].note);
  };
  const saveEditedSurveyorNote = (index) => {
    const updatedDocs = [...formData.surveyorDoc];
    updatedDocs[index] = {
      ...updatedDocs[index],
      note: editSurveyorNote.trim(),
    };

    setFormData((prev) => ({
      ...prev,
      surveyorDoc: updatedDocs,
    }));
    setEditingSurveyorIndex(null);
    setEditingSurveyorNoteIndex(null);
    setEditSurveyorNote("");
  };
  const handleLandUseUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const f = new FormData();
    f.append("image", file);
    setisLoading3(true);

    try {
      const response = await uploadKypDocument(f, "landUseDoc");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      if (editingLandUseIndex !== null) {
        const updatedDocs = [...formData.landUseDoc];
        updatedDocs[editingLandUseIndex] = {
          url: fileUrl,
          note: landUseNote?.trim() || updatedDocs[editingLandUseIndex].note,
        };
        setFormData((prev) => ({
          ...prev,
          landUseDoc: updatedDocs,
        }));
        setEditingLandUseIndex(null);
      } else {
        setFormData((prev) => ({
          ...prev,
          landUseDoc: [
            ...(prev.landUseDoc || []),
            {
              url: fileUrl,
              note: landUseNote?.trim() || "",
            },
          ],
        }));
      }
      setLandUseNote("");
    } catch (error) {
      console.error("❌ Error uploading landuse document:", error);
    } finally {
      setisLoading3(false);
      if (event?.target) event.target.value = "";
    }
  };
  const handleLandUseDelete = (index) => {
    if (landUseref.current) {
      landUseref.current.value = null; // Reset file input
    }
    const updatedDocs = [...formData.landUseDoc];
    updatedDocs.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      landUseDoc: updatedDocs,
    }));
    if (editingLandUse === index) {
      setEditLandUseNote(null);
      setEditingLandUseIndex(null);
    }
  };
  const [selectOthersForConsultants, setSelectOthersForConsultants] = useState(formData.consultantType === 'other' ? true : false);
  const [selectOthersForcontractors, setSelectOthersForcontractors] = useState(formData.contractorType === 'other' ? true : false);
  const startEditingLandUseNote = (index) => {
    setEditingLandUseIndex(index);
    setEditLandUseNote(formData.landUseDoc[index].note);
  };
  const saveEditedLandUseNote = (index) => {
    const updatedDocs = [...formData.landUseDoc];
    updatedDocs[index] = {
      ...updatedDocs[index],
      note: editLandUseNote,
    };
    setFormData((prev) => ({
      ...prev,
      landUseDoc: updatedDocs,
    }));

    setEditingLandUseIndex(null);
    setEditLandUseNote("");
  };
  const handlePostalCodeChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, postalCode: value });

    if (!value) {
      setErrors({ ...errors, postalCode: "Postal code is required" });
      setTimeout(() => {
        setErrors((prev) => ({ ...prev, postalCode: "" }));
      }, 3000);
    } else if (value.length !== 6) {
      setErrors({ ...errors, postalCode: "Postal code should be 6 digits" });
      setTimeout(() => {
        setErrors((prev) => ({ ...prev, postalCode: "" }));
      }, 3000);
    } else {
      setErrors({ ...errors, postalCode: "" });
    }
  };
  const handleNeighbourDocUpload = async (
    event,
    direction,
    index,
    editIndex = null
  ) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const f = new FormData();
    f.append("image", file);

    const version =
      (neighbourUploadVersionRef.current[direction] =
        (neighbourUploadVersionRef.current[direction] || 0) + 1);
    const tempNoteSnapshot = tempNote[direction] ?? "";

    setNeighbourDirectionLoading((prev) => ({ ...prev, [direction]: true }));

    try {
      const response = await uploadKypDocument(f, `neighbour:${direction}`);
      if (!response?.Location) {
        return;
      }
      if (neighbourUploadVersionRef.current[direction] !== version) {
        return;
      }
      const fileUrl = response.Location;

      setFormData((prev) => {
        const neighbours = [...(prev.neighbourDetails || [])];
        const idx =
          neighbours.findIndex((n) => n.direction === direction);
        if (idx === -1) {
          return prev;
        }
        const currentDocuments = [...(neighbours[idx]?.document || [])];
        const noteForDoc =
          tempNoteSnapshot ||
          (editIndex !== null && editIndex >= 0
            ? currentDocuments[editIndex]?.note || ""
            : "");

        const newDocument = {
          url: fileUrl,
          note: noteForDoc,
        };

        let updatedDocuments;
        if (editIndex !== null && editIndex >= 0) {
          updatedDocuments = [...currentDocuments];
          updatedDocuments[editIndex] = newDocument;
        } else {
          updatedDocuments = [...currentDocuments, newDocument];
        }

        neighbours[idx] = {
          ...neighbours[idx],
          document: updatedDocuments,
          documents: undefined,
        };

        return { ...prev, neighbourDetails: neighbours };
      });

      setTempNote((prev) => ({
        ...prev,
        [direction]: "",
      }));
      setEditDocIndex((prev) => ({ ...prev, [direction]: null }));
    } catch (error) {
      console.error(`Error uploading ${direction} neighbour document:`, error);
    } finally {
      if (neighbourUploadVersionRef.current[direction] === version) {
        setNeighbourDirectionLoading((prev) => ({
          ...prev,
          [direction]: false,
        }));
      }
      if (event?.target) {
        event.target.value = "";
      }
    }
  };
  const handleNeighbourDocDelete = (direction, index) => {
    neighbourUploadVersionRef.current[direction] =
      (neighbourUploadVersionRef.current[direction] || 0) + 1;
    setNeighbourDirectionLoading((prev) => ({ ...prev, [direction]: false }));
    const ref = uploadRefs.current[direction];
    if (ref) ref.value = "";
    const updatedNeighbours = formData.neighbourDetails.map((item) =>
      item.direction === direction
        ? {
          ...item,
          document: item.document.filter((_, i) => i !== index),
        }
        : item
    );

    setFormData((prev) => ({
      ...prev,
      neighbourDetails: updatedNeighbours,
    }));
  };
  const handleDrawingDocUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setisLoading11(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "drawings");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        drawings: {
          url: fileUrl,
          note: editingDrawing ? prev.drawings?.note || "" : drawingNote.trim(),
        },
      }));

      setDrawingNote("");
      setEditingDrawing(false);
    } catch (error) {
      console.error("❌ Error uploading drawing doc:", error);
    } finally {
      setisLoading11(false);
    }
  };
  const startNoteEdit = (direction, index) => {
    setEditingNote((prev) => ({
      ...prev,
      [direction]: {
        ...(prev[direction] || {}),
        [index]: true,
      },
    }));

    setEditedNotes((prev) => ({
      ...prev,
      [direction]: {
        ...(prev[direction] || {}),
        [index]:
          formData.neighbourDetails.find((item) => item.direction === direction)
            ?.document?.[index]?.note || "",
      },
    }));
  };
  const handleNoteChange = (direction, index, value) => {
    setEditedNotes((prev) => ({
      ...prev,
      [direction]: {
        ...(prev[direction] || {}),
        [index]: value,
      },
    }));
  };
  const cancelNoteEdit = (direction, index) => {
    setEditingNote((prev) => ({
      ...prev,
      [direction]: {
        ...(prev[direction] || {}),
        [index]: false,
      },
    }));
  };
  const saveNote = (direction, index) => {
    const updatedNeighbours = [...formData.neighbourDetails];
    const neighbourIndex = updatedNeighbours.findIndex(
      (item) => item.direction === direction
    );

    if (neighbourIndex !== -1) {
      const docs = [...(updatedNeighbours[neighbourIndex].document || [])];
      docs[index] = {
        ...docs[index],
        note: editedNotes[direction]?.[index] || "",
      };
      updatedNeighbours[neighbourIndex].document = docs;

      setFormData((prev) => ({
        ...prev,
        neighbourDetails: updatedNeighbours,
      }));
    }

    setEditingNote((prev) => ({
      ...prev,
      [direction]: {
        ...(prev[direction] || {}),
        [index]: false,
      },
    }));
  };
  const handleDrawingDocDelete = () => {
    if (neighbourRef.current) {
      neighbourRef.current.value = null; // Reset file input
    }
    setFormData((prev) => ({ ...prev, drawings: null }));
    setDrawingNote("");
    setEditingDrawing(false);
    setEditingDrawingNote(false);
    setEditDrawingNote("");
  };
  const startNeighbourNoteEdit = (index, docIndex, currentNote) => {
    setEditingNote({ index, docIndex });
    setNoteInput(currentNote);
  };
  const startEditingDrawingNote = () => {
    setEditingDrawingNote(true);
    setEditDrawingNote(formData.drawings?.note || "");
  };
  const saveEditedDrawingNote = () => {
    setFormData((prev) => ({
      ...prev,
      drawings: {
        ...prev.drawings,
        note: editDrawingNote.trim(),
      },
    }));
    setEditingDrawingNote(false);
    setEditDrawingNote("");
  };
  const handleFutureOwnershipUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setisLoading8(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "futureOwnershipDoc");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        futureOwnershipDoc: {
          url: fileUrl,
          note: editingFutureOwnership
            ? prev.futureOwnershipDoc?.note || ""
            : futureOwnershipNote.trim(),
        },
      }));

      setFutureOwnershipNote("");
      setEditingFutureOwnership(false);
    } catch (error) {
      console.error("❌ Error uploading future ownership document:", error);
    } finally {
      setisLoading8(false);
    }
  };
  const handleFutureOwnershipDelete = () => {
    if (futureOwnershipRef.current) {
      futureOwnershipRef.current.value = null; // Reset file input
    }
    setFormData((prev) => ({ ...prev, futureOwnershipDoc: null }));
    setFutureOwnershipNote("");
    setEditingFutureOwnership(false);
    setEditingFutureOwnershipNote(false);
    setEditFutureOwnershipNote("");
  };
  const startEditingFutureOwnershipNote = () => {
    setEditingFutureOwnershipNote(true);
    setEditFutureOwnershipNote(formData.futureOwnershipDoc?.note || "");
  };
  const startEditingOtherSideCNote = () => {
    setEditOtherSideCNote(formData?.otherSideC?.note || "");
    setEditingOtherSideCNote(true);
  };
  const saveEditedOtherSideCNote = () => {
    setFormData((prev) => ({
      ...prev,
      otherSideC: {
        ...prev.otherSideC,
        note: editOtherSideCNote,
      },
    }));
    setEditingOtherSideCNote(false);
  };
  const saveEditedFutureOwnershipNote = () => {
    setFormData((prev) => ({
      ...prev,
      futureOwnershipDoc: {
        ...prev.futureOwnershipDoc,
        note: editFutureOwnershipNote.trim(),
      },
    }));
    setEditingFutureOwnershipNote(false);
    setEditFutureOwnershipNote("");
  };
  const handleOwnerPhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setisLoadingowner(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "ownerPhoto");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        ownerPhoto: {
          url: fileUrl,
          note: editingOwnerPhoto
            ? prev.ownerPhoto?.note || ""
            : ownerPhotoNote.trim(),
        },
      }));

      setOwnerPhotoNote("");
      setEditingOwnerPhoto(false);
    } catch (error) {
      console.error("❌ Error uploading owner photo:", error);
    } finally {
      setisLoadingowner(false);
    }
  };
  const handleOwnerPhotoDelete = () => {
    setFormData((prev) => ({ ...prev, ownerPhoto: null }));
    setOwnerPhotoNote("");
    setEditingOwnerPhoto(false);
    setEditingOwnerPhotoNote(false);
    setEditOwnerPhotoNote("");
  };
  const startEditingOwnerPhotoNote = () => {
    setEditingOwnerPhotoNote(true);
    setEditOwnerPhotoNote(formData.ownerPhoto?.note || "");
  };
  const saveEditedOwnerPhotoNote = () => {
    setFormData((prev) => ({
      ...prev,
      ownerPhoto: {
        ...prev.ownerPhoto,
        note: editOwnerPhotoNote.trim(),
      },
    }));
    setEditingOwnerPhotoNote(false);
    setEditOwnerPhotoNote("");
  };
  const handleForms = async (step) => {
    const steps = ["step1", "step2", "step3", "step4", "step5", "step6"];
    const targetIndex = steps.indexOf(step);
    const currentIndex = steps.indexOf(activeStep);

    let canNavigate = true;
    if (targetIndex > currentIndex) {
      for (let i = 0; i < targetIndex; i++) {
        if (!isStepRequiredFieldsFilled(steps[i])) {
          canNavigate = false;
          break;
        }
      }
    }

    if (canNavigate) {
      setActiveStep(step);
      setFormError("");
    } else {
      setFormError("Please fill in all required details before proceeding to the next steps.");
      setTimeout(() => setFormError(""), 3000);
    }
  };
  const handleBack = (e, name) => {
    e.preventDefault();
    setActiveStep(name);
  };
  const [DisableButton, setDisableButton] = useState(false)
  const handleNext = async (e, step) => {
    e.preventDefault();

    let newErrors = {};
    let newFieldErrors = {};
    const docs = formData.Department_wise_Documents;

    if (activeStep === "step1") {
      if (!formData.ownerName || !formData.ownerName.trim()) newErrors.ownerName = "Owner Name is required";

      if (!formData.typeOfProperty)
        newErrors.typeOfProperty = "Type of Property is required";
      if (!formData.location) newErrors.location = "Location is required";
      if (!formData.ownedSince)
        newErrors.ownedSince = "Owned Since is required";

      let hasDocumentError = false;
      let hasDepartmentNameError = false;
      for (const category of categories1) {
        const departmentName = textInputs[category];
        if (!departmentName || departmentName.trim() === "") {
          newFieldErrors[`${category}-departmentName`] = "Department Name is required";
          hasDepartmentNameError = true;
        }
      }
      for (const category of categories1) {
        if (!fileInputs1[category] || fileInputs1[category].length === 0) {
          hasDocumentError = true;
          break;
        }
      }

      if (hasDocumentError) {
        newErrors.Department_wise_Documents = "Departmentwise Documents is required";
      } else {
        for (const category of categories1) {
          const documents = fileInputs1[category] || [];

          documents.forEach((doc, docIndex) => {
            if (!doc.file) {
              newFieldErrors[`${category}-${docIndex}-file`] = "Document file is required";
            }

            const requiredFields = [
              "typeofdocument",
              "departmentofregistrationandstamps",
              "datethedocumentwasissued",
              "nameofissuingofficer",
              "designationofofficer",
              "officesituatedat"
            ];

            requiredFields.forEach(fieldKey => {
              if (!doc?.fields?.[fieldKey]) {
                const errorKey = `${category}-${docIndex}-${fieldKey}`;
                newFieldErrors[errorKey] = "This field is required";
              }
            });

            if (doc?.fields?.date_of_the_document_issued) {
              const dateValue = new Date(doc.fields.date_of_the_document_issued);
              const today = new Date();

              if (dateValue > today) {
                const errorKey = `${category}-${docIndex}-date_of_the_document_issued`;
                newFieldErrors[errorKey] = "Date cannot be in the future";
              }
            }
          });
        }
      }
      setErrors(newErrors);
      setFieldErrors(newFieldErrors);
      setTimeout(() => {
        setErrors({});
        setFieldErrors({});
      }, 2000);
      if (Object.keys(newErrors).length > 0 || Object.keys(newFieldErrors).length > 0) {

        setTimeout(() => {
          if (Object.keys(newErrors).length > 0) {
            setTimeout(() => {
              setErrors({});
              setFieldErrors({});
            }, 1000);
          }
        }, 3000);
        return;
      } else {
        setErrors({});
        setFieldErrors({});
        setLoader(true);
        setCompletedSteps({ ...completedSteps, [activeStep]: true });
        setActiveStep(step);

        try {
          const documents = {
            categories: categories1,
            files: sanitizeFileInputs(fileInputs1),
            descriptions: textInputs,
          };
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;

          if (targetKypId) {
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              Department_wise_Documents: documents,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          } else {
            const jsonData = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              Department_wise_Documents: documents,
              isFilled: false
            };
            const saveKyp = await PropertiesService.KnowYourProperty(jsonData);
            console.log(saveKyp, 'property saved successfully');
          }
        } catch (error) {
          console.error("Error updating step 1:", error);
        } finally {
          setLoader(false);
        }
      }
    }
    if (activeStep === "step2") {
      console.log(formData.postalCode, 'formData.postalCode')
      if (!formData.marketValue)
        newErrors.marketValue = "Market Value is required";
      if (!formData.selfDeclaration)
        newErrors.selfDeclaration = "Self Declaration is required";
      if (!formData.postalCode) {
        newErrors.postalCode = "Postal Code is required";
      } else if (!/^[0-9]{6}$/.test(formData?.postalCode)) {
        newErrors.postalCode = "Postal Code should be 6 digits";
      }
      if (!formData.constructionDetails)
        newErrors.constructionDetails = "Construction Details are required";
      if (formData.architectDoc.length === 0)
        newErrors.architectDoc = "Architect Document is required";
      if (formData.surveyorDoc.length === 0)
        newErrors.surveyorDoc = "Surveyor Document is required";
      if (formData.landUseDoc.length === 0)
        newErrors.landUseDoc = "Land Use Document is required";

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTimeout(() => {
          setErrors({});
        }, 3000);
        return;
      } else {
        setLoader(true);
        try {
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;
          if (targetKypId) {
            const documents = {
              categories: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.categories || categories1,
              files: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.files || fileInputs1,
              descriptions: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.descriptions || textInputs,
            };
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId,
              Department_wise_Documents: documents
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          }
        } catch (error) {
          console.error("Error updating step 2:", error);
        } finally {
          setLoader(false);
        }
        setErrors({});
        setCompletedSteps({ ...completedSteps, [activeStep]: true });
        setActiveStep(step);
      }
    }

    if (activeStep === "step3") {
      const newErrors = {};

      if (!formData.neighbourDetails || formData.neighbourDetails.length === 0) {
        newErrors.neighbourDetails = "Neighbour Details are required";
      } else {
        formData.neighbourDetails.forEach((item) => {
          if (!item.name || item.name.trim() === "") {
            newErrors[`neighbour_${item.direction}`] = `${item.direction.charAt(0).toUpperCase() + item.direction.slice(1)} neighbour name is required`;
          }
          if (!item.document || item.document.length === 0) {
            if (!newErrors.neighbourDetails || typeof newErrors.neighbourDetails !== "object") {
              newErrors.neighbourDetails = {};
            }
            newErrors.neighbourDetails[item.direction] = `${item.direction.charAt(0).toUpperCase() + item.direction.slice(1)} document is required`;
          }
        });
      }
      if (!formData.selfDeclaration2) {
        newErrors.selfDeclaration2 = "Self Declaration is required";
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTimeout(() => {
          setErrors({});
        }, 3000);
        return;
      } else {
        setLoader(true);
        try {
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;
          if (targetKypId) {
            const documents = {
              categories: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.categories || categories1,
              files: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.files || fileInputs1,
              descriptions: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.descriptions || textInputs,
            };
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId,
              Department_wise_Documents: documents
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          }
        } catch (error) {
          console.error("Error updating step 3:", error);
        } finally {
          setLoader(false);
        }
        setErrors({});
        setCompletedSteps({ ...completedSteps, [activeStep]: true });
        setActiveStep(step);
      }
    }

    if (activeStep === "step4") {
      if (!formData.futureOwnershipDoc || !formData.futureOwnershipDoc.url)
        newErrors.futureOwnershipDoc = "Future Ownership Document is required";
      if (!formData.selfDeclaration3)
        newErrors.selfDeclaration3 = "Self Declaration is required";
      if (!formData.email) {
        newErrors.email = "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Enter a valid email address";
      }

      if (!formData.filledBy) {
        newErrors.filledBy = "Please select who has filled out this form";
      }

      if (formData.filledBy === "other") {
        if (!formData.otherPersonDetails.dob)
          newErrors.otherPersonDob = "Date of Birth is required";
        else if (formData.otherPersonDetails.dob > maxDobDate)
          newErrors.otherPersonDob = "Date of Birth cannot be in the future";
        if (!formData.otherPersonDetails.age)
          newErrors.otherPersonAge = "Age is required";
        if (!formData.otherPersonDetails.email) {
          newErrors.otherPersonEmail = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.otherPersonDetails.email)) {
          newErrors.otherPersonEmail = "Enter a valid email address";
        }
        if (!formData.otherPersonDetails.address)
          newErrors.otherPersonAddress = "Address is required";
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTimeout(() => {
          setErrors({});
        }, 3000);
        return;
      } else {
        setLoader(true);
        try {
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;
          if (targetKypId) {
            const documents = {
              categories: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.categories || categories1,
              files: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.files || fileInputs1,
              descriptions: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.descriptions || textInputs,
            };
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId,
              Department_wise_Documents: documents
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          }
        } catch (error) {
          console.error("Error updating step 4:", error);
        } finally {
          setLoader(false);
        }
        setErrors({});
        setActiveStep(step);
        setCompletedSteps({ ...completedSteps, [activeStep]: true });
      }
    }
    if (activeStep === "step5") {
      if (
        !formData.consentSharing ||
        !formData.consentSurvey ||
        !formData.futureTitleGuarantee ||
        !formData.internationalGovernance
      ) {
        newErrors.checkboxes = "Please select all checkboxes.";
      }
      if (!formData.amsl) newErrors.amsl = "AMSL is required";
      if (!formData.roadDetails)
        newErrors.roadDetails = "Road Details are required";
      if (!formData.sro) newErrors.sro = "SRO is required";
      if (!formData.pd) newErrors.pd = "Post Office detail is required";
      if (!formData.drawings) newErrors.drawings = "Drawings are required";
      if (!formData.legalStatus)
        newErrors.legalStatus = "Legal Status is required";
      if (!formData.financialStatus)
        newErrors.financialStatus = "Financial Status is required";
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTimeout(() => {
          setErrors({});
        }, 3000);
        return;
      } else {
        setLoader(true);
        try {
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;
          if (targetKypId) {
            const documents = {
              categories: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.categories || categories1,
              files: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.files || fileInputs1,
              descriptions: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.descriptions || textInputs,
            };
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId,
              Department_wise_Documents: documents
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          }
        } catch (error) {
          console.error("Error updating step 5:", error);
        } finally {
          setLoader(false);
        }
        setErrors({});
        setActiveStep(step);
        setCompletedSteps({ ...completedSteps, [activeStep]: true });
      }
    }

    if (activeStep === "step6") {
      if (!formData.ownerPhoto)
        newErrors.ownerPhoto = "Owner Photo is required";
      if (!formData.firmType) newErrors.firmType = "Firm Type is required";
      if (!formData.mainElevation)
        newErrors.mainElevation = "Main Elevation is required";
      if (!formData.otherSideA)
        newErrors.otherSideA = "Other Side A is required";
      if (!formData.otherSideB)
        newErrors.otherSideB = "Other Side B is required";
      if (!formData.otherSideC)
        newErrors.otherSideC = "Other Side C is required";
      if (!formData.buildingAge)
        newErrors.buildingAge = "Building Age is required";
      if (!formData.buildingDescription)
        newErrors.buildingDescription = "Building Description is required";
      if (!formData.architectDetails)
        newErrors.architectDetails = "Architect Details are required";
      if (!formData.civilEngineerDetails)
        newErrors.civilEngineerDetails = "Civil Engineer Details are required";
      if (!formData.consultants)
        newErrors.consultants = "Consultants are required";
      if (!formData.contractors)
        newErrors.contractors = "Contractors are required";
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setTimeout(() => {
          setErrors({});
        }, 3000);
        return;
      } else {
        setLoader(true);
        try {
          const response = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
          const filterFilledKYPS = response?.data?.filter((x) => x.isFilled === false && x.userId === userDetails?.user_id) || [];
          const targetKypId = editKypId || filterFilledKYPS[0]?._id;
          if (targetKypId) {
            const documents = {
              categories: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.categories || categories1,
              files: filterFilledKYPS[0]?.Department_wise_Documents[0]?.files || fileInputs1,
              descriptions: filterFilledKYPS[0]?.Department_wise_Documents?.[0]?.descriptions || textInputs,
            };
            const updateKypObject = {
              ...formData,
              aadhar: parseInt(formData.aadhar, 10) || formData.aadhar,
              amsl: parseFloat(formData.amsl) || formData.amsl,
              marketValue: parseFloat(formData.marketValue) || formData.marketValue,
              buildingAge: parseInt(formData.buildingAge, 10) || formData.buildingAge,
              postalCode: parseInt(formData.postalCode, 10) || formData.postalCode,
              ownedSince: parseInt(formData.ownedSince, 10) || formData.ownedSince,
              mobile: parseInt(formData.mobile, 10) || formData.mobile,
              taxDetails: parseInt(formData.taxDetails, 10) || formData.taxDetails,
              selectedPropertyType: parseFloat(formData.selectedPropertyType) || formData.selectedPropertyType,
              isFilled: editKypId ? formData.isFilled : false,
              KypId: targetKypId,
              Department_wise_Documents: documents
            };
            const updateKyp = await PropertiesService.editkyp(updateKypObject);
            console.log(updateKyp, 'property updated successfully');
          }
        } catch (error) {
          console.error("Error updating step 6:", error);
        } finally {
          setLoader(false);
        }
        setErrors({});
        setActiveStep(step);
      }
    }
  };
  const handleOtherSideBUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setIsLoadingOtherSideB(true);

    const formDataUpload = new FormData();
    formDataUpload.append("image", file);

    try {
      const response = await uploadKypDocument(formDataUpload, "otherSideB");
      if (!response?.Location) return;
      const fileUrl = response.Location;

      setFormData((prev) => ({
        ...prev,
        otherSideB: {
          url: fileUrl,
          note: editingOtherSideB
            ? prev.otherSideB?.note || ""
            : otherSideBNote.trim(),
        },
      }));

      setOtherSideBNote("");
      setEditingOtherSideB(false);
    } catch (error) {
      console.error("❌ Error uploading Other Side B:", error);
    } finally {
      setIsLoadingOtherSideB(false);
    }
  };
  const handleOtherSideBDelete = () => {
    setFormData((prev) => ({ ...prev, otherSideB: null }));
    setOtherSideBNote("");
    setEditingOtherSideB(false);
    setEditingOtherSideBNote(false);
    setEditOtherSideBNote("");
  };
  const startEditingOtherSideBNote = () => {
    setEditingOtherSideBNote(true);
    setEditOtherSideBNote(formData.otherSideB?.note || "");
  };
  const saveEditedOtherSideBNote = () => {
    setFormData((prev) => ({
      ...prev,
      otherSideB: {
        ...prev.otherSideB,
        note: editOtherSideBNote.trim(),
      },
    }));
    setEditingOtherSideBNote(false);
    setEditOtherSideBNote("");
  };
  const addDocumentSection = () => {
    if (!selectedDepartment) return;
    setDocuments([
      ...documents,
      { department: selectedDepartment, file: null, fields: {} },
    ]);
  };
  useEffect(() => {
    if (documents.length === 0) {
      setSearchTerm("");
    }
  }, [documents]);

  useEffect(() => {
    getAllDepartmentsList();
    // Check for pending draft and show confirmation modal (skip if editing)
    if (!editKypId) {
      const navigationEntries = performance.getEntriesByType('navigation');
      const isReload =
        (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') ||
        (window.performance && window.performance.navigation && window.performance.navigation.type === 1);

      if (!isReload) {
        (async () => {
          const drafts = await getActiveKypDrafts();
          if (drafts && drafts.length > 0) {
            setDraftData(drafts[0]);
            setShowDraftModal(true);
          }
        })();
      }
    } else {
      getKypDetails(editKypId);
    }
  }, [editKypId]);
  const getKypDetails = async (kypIdForEdit = "") => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    let list = [];
    if (kypIdForEdit) {
      const findKyp = await PropertiesService.getKpiLists({ userId: userDetails.user_id });
      list = Array.isArray(findKyp?.data) ? findKyp.data : [];
    } else {
      list = await getActiveKypDrafts();
    }
    const findFilledOrNot = kypIdForEdit
      ? list.filter((x) => String(x?._id) === String(kypIdForEdit) && x.userId === userDetails.user_id)
      : list.filter((x) => x.isFilled === false && x.userId === userDetails.user_id);
    if (findFilledOrNot.length > 0) {
      const savedKyp = findFilledOrNot[0];
      const savedDocs = savedKyp?.Department_wise_Documents?.[0];
      if (savedDocs?.categories) {
        setCategories1(savedDocs.categories);
      }
      if (savedDocs?.files) {
        setFileInputs1(savedDocs.files);
      }
      if (savedDocs?.descriptions) {
        setTextInputs(savedDocs.descriptions);
      }
      if (savedKyp?.typeOfProperty) {
        setTypeOfProperty(savedKyp.typeOfProperty);
      }
      const normalizedBankLoanChoice = getLookupKeyByValue(
        BANK_LOAN_LABELS,
        savedKyp?.bankLoanChoiceValue || savedKyp?.bankLoanChoice || savedKyp?.bankLoanChoiceText
      );
      const normalizedMarketPlanChoice = getLookupKeyByValue(
        MARKET_PLAN_LANDUSE_LABELS,
        savedKyp?.marketPlanLandUseChoiceValue || savedKyp?.marketPlanLandUseChoice || savedKyp?.marketPlanLandUseChoiceText
      );
      const normalizedNoMasterPlanPropertyType = getLookupKeyByValue(
        NO_MASTER_PLAN_PROPERTY_TYPE_LABELS,
        savedKyp?.noMasterPlanPropertyTypeValue || savedKyp?.noMasterPlanPropertyType || savedKyp?.noMasterPlanPropertyTypeText
      );
      const normalizedNoMasterPlanDeclaration =
        !!savedKyp?.noMasterPlanDeclarationBoolean ||
        !!savedKyp?.noMasterPlanDeclaration ||
        !!normalizedNoMasterPlanPropertyType;

      setFormData((prev) => ({
        ...savedKyp,
        Department_wise_Documents: savedKyp?.Department_wise_Documents,
        futureOwnershipDoc: savedKyp?.futureOwnershipDoc,
        otherPersonDetails: {
          name: savedKyp?.otherPersonDetails?.[0]?.name || "",
          email: savedKyp?.otherPersonDetails?.[0]?.email || "",
          age: savedKyp?.otherPersonDetails?.[0]?.age || "",
          dob: savedKyp?.otherPersonDetails?.[0]?.dob || "",
          address: savedKyp?.otherPersonDetails?.[0]?.address || "",
        },
        marketPlanLandUseChoice: normalizedMarketPlanChoice,
        bankLoanChoice: normalizedBankLoanChoice,
        noMasterPlanDeclaration: normalizedNoMasterPlanDeclaration,
        noMasterPlanPropertyType: normalizedNoMasterPlanPropertyType,
        futureOwnershipDoc: savedKyp?.futureOwnershipDoc?.[0],
        ownerPhoto: savedKyp?.ownerPhoto?.[0],
        mainElevation: savedKyp?.mainElevation?.[0],
        otherSideA: savedKyp?.otherSideA?.[0],
        otherSideB: savedKyp?.otherSideB?.[0],
        otherSideC: savedKyp?.otherSideC?.[0],
      }));

    } else {
      setFormData([])
    }
  }
  const setOpenPaymentShow = () => {
    setRazorPayShow(true)
    setpaymentStatusModel(false)
    setFormData({
      userId: userDetails?.user_id || "",
      typeOfProperty: "",
      ownerName: "",
      aadhar: "",
      selectedPropertyType: "",
      location: "",
      ownedSince: "",
      taxDetails: "",
      marketValue: "",
      selfDeclaration: false,
      selfDeclaration2: false,
      selfDeclaration3: false,
      googleLocation: "",
      postalCode: "",
      constructionDetails: "",
      architectDoc: [],
      surveyorDoc: [],
      landUseDoc: [],

      neighbourDetails: [
        { direction: "east", name: "", document: [] },
        { direction: "west", name: "", document: [] },
        { direction: "north", name: "", document: [] },
        { direction: "south", name: "", document: [] },
      ],


      futureOwnershipDoc: [],
      email: "",
      mobile: "",
      nomineeDetail: "",
      filledBy: "", // "owner" or "other"
      otherPersonDetails: {
        name: "",
        dob: "",
        age: "",
        email: "",
        address: ""
      },
      ownershipCertificateDeclaration: false,
      marketPlanLandUseChoice: "",
      noMasterPlanDeclaration: false,
      noMasterPlanPropertyType: "",
      bankLoanChoice: "",
      titlePossessionConsent: false,
      consentSharing: false,
      consentSurvey: false,
      futureTitleGuarantee: false,
      internationalGovernance: false,
      amsl: "",
      roadDetails: "",
      sro: "",
      pd: "",
      drawings: [],
      legalStatus: "",
      financialStatus: "",
      firmType: "",
      otherFirmDetail: "",
      ownerPhoto: [],
      mainElevation: [],
      otherSideA: [],
      otherSideB: [],
      otherSideC: [],
      buildingAge: "",
      buildingDescription: "",
      architectDetails: "",
      civilEngineerDetails: "",
      consultants: [],
      contractors: [],
      consultantType: "",
      contractorType: ""
    });
  }
  const closeTheTab = () => {
    setpaymentStatusModel(true)
    setRazorPayShow(false)
  }

  const kypMainSteps = [
    { key: "step1", title: "Step 1 - Property Basic Details" },
    { key: "step2", title: "Step 2 - Government Department Documents" },
    { key: "step3", title: "Step 3 - Technical Survey Details" },
    { key: "step4", title: "Step 4 - Ownership & Legal Chain" },
    { key: "step5", title: "Step 5 - Building & Structure Details" },
    { key: "step6", title: "Step 6 - Final Review" },
  ];
  const activeStepMeta =
    kypMainSteps.find((stepItem) => stepItem.key === activeStep) ||
    kypMainSteps[0];

  useEffect(() => {
    const modalOverlay = document.querySelector(".modal-overlay");
    if (modalOverlay) {
      if (paymentStatusModel) {
        modalOverlay.style.display = "none";
      } else {
        modalOverlay.style.display = "flex";
      }
    }
  }, [paymentStatusModel]);

  const isStepRequiredFieldsFilled = (stepKey) => {
    switch (stepKey) {
      case "step1":
        return !!(formData.ownerName?.trim() && formData.typeOfProperty && formData.location?.trim());
      case "step2":
        return !!(fileInputs1 && Object.values(fileInputs1).some(arr => Array.isArray(arr) && arr.some(file => file && (file.file || file.data))));
      case "step3":
        return !!(formData.surveyorDoc && formData.surveyorDoc.length > 0 && formData.landUseDoc && formData.landUseDoc.length > 0);
      case "step4":
        return !!(formData.futureOwnershipDoc && formData.futureOwnershipDoc.length > 0);
      case "step5":
        return !!(formData.architectDoc && formData.architectDoc.length > 0);
      case "step6":
        return true;
      default:
        return false;
    }
  };

  const getStepProgressPercent = (stepKey) => {
    let filledCount = 0;
    let totalFields = 0;

    switch (stepKey) {
      case "step1":
        const step1Fields = [
          formData.filledBy,
          formData.typeOfProperty,
          formData.ownerName,
          formData.location,
          formData.googleLocation,
          formData.postalCode
        ];
        if (formData.typeOfProperty === "Other") step1Fields.push(formData.selectedPropertyType);

        totalFields = step1Fields.length;
        filledCount = step1Fields.filter(val => val && val.toString().trim() !== "").length;
        break;

      case "step2":
        totalFields = 1; // at least one doc uploaded
        let hasFiles1 = fileInputs1 && Object.values(fileInputs1).some(arr => Array.isArray(arr) && arr.some(file => file && (file.file || file.data)));
        if (hasFiles1) filledCount++;
        break;

      case "step3":
        const step3Fields = [
          formData.surveyorDoc,
          formData.landUseDoc
        ];
        totalFields = step3Fields.length;
        filledCount = step3Fields.filter(val => val && val.length > 0).length;
        break;

      case "step4":
        const step4Fields = [
          formData.futureOwnershipDoc
        ];
        totalFields = step4Fields.length;
        filledCount = step4Fields.filter(val => val && val.length > 0).length;
        break;

      case "step5":
        const step5Fields = [
          formData.constructionDetails,
          formData.buildingAge,
          formData.architectDoc
        ];
        totalFields = step5Fields.length;
        filledCount = step5Fields.filter(val => (Array.isArray(val) ? val.length > 0 : val && val.toString().trim() !== "")).length;
        break;

      case "step6":
        return completedSteps["step6"] ? 100 : (activeStep === "step6" ? 50 : 0);

      default:
        return 0;
    }

    if (totalFields === 0) return 0;

    const pct = Math.round((filledCount / totalFields) * 100);
    if (pct === 100) return 100;
    if (completedSteps[stepKey] && isStepRequiredFieldsFilled(stepKey)) return 100;
    return pct;
  };

  const getStepProgress = (stepKey) => {
    const pct = getStepProgressPercent(stepKey);
    if (pct === 100) return "complete";
    if (pct > 0) return "partial";
    return "empty";
  };

  const getLineFillWidth = (fromStepKey) => {
    const steps = kypMainSteps.map((s) => s.key);
    const activeIdx = steps.indexOf(activeStep);
    const fromIdx = steps.indexOf(fromStepKey);

    if (activeIdx > fromIdx) return "100%";
    if (activeIdx === fromIdx) return `${getStepProgressPercent(fromStepKey)}%`;
    return "0%";
  };

  const getLineStatus = (fromStepKey) => {
    const steps = kypMainSteps.map((s) => s.key);
    const activeIdx = steps.indexOf(activeStep);
    const fromIdx = steps.indexOf(fromStepKey);

    if (activeIdx > fromIdx) return "status-complete";
    if (activeIdx === fromIdx) {
      const pct = getStepProgressPercent(fromStepKey);
      return pct > 0 ? "status-partial" : "status-empty";
    }
    return "status-empty";
  };

  return (
    <div className="prestige-page-bg">
      {/* ── Pending KYP Draft Confirmation Modal ── */}
      {showDraftModal && (
        <div className="draft-modal-overlay" onClick={() => setShowDraftModal(false)}>
          <div className="draft-modal-card" onClick={e => e.stopPropagation()}>
            <div className="draft-modal-icon">📋</div>
            <h2 className="draft-modal-title">
              Your previous <strong>KYP request</strong><br /> is still <strong>on hold</strong>
            </h2>
            <p className="draft-modal-subtitle">
              Would you like to continue?
            </p>
            <div className="draft-modal-actions">
              <button
                className="draft-modal-btn yes"
                onClick={() => { setShowDraftModal(false); getKypDetails(''); }}
              >
                Yes
              </button>
              <button
                className="draft-modal-btn no"
                onClick={() => setShowDraftModal(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="prestige-main-container" data-onboarding="form-screen">
        <div className="prestige-header">
          <div className="prestige-header-top">
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {/* {logo && <img src={logo} alt="doCity Logo" style={{ height: '34px' }} />} */}
              <h1 className="prestige-header-title">{propertyRequestSwitch}</h1>
            </div>
            <div className="prestige-header-nav">
              <span onClick={() => { if (typeof closeModal === 'function') closeModal(); else navigate('/'); }}>Close</span>
            </div>
          </div>

          <div className="prestige-stepper">
            {kypMainSteps.map((stepItem, index) => {
              const activeIdx = kypMainSteps.findIndex((s) => s.key === activeStep);
              const isCompleted = index < activeIdx;
              const isActive = stepItem.key === activeStep;
              const stepStatus = isActive ? "active" : isCompleted ? "status-complete" : "status-empty";
              return (
                <React.Fragment key={stepItem.key}>
                  <div
                    className={`prestige-step ${stepStatus}`}
                    onClick={() => handleForms(stepItem.key)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="prestige-step-circle">{index + 1}</div>
                    <div className="prestige-step-label">{stepItem.title.split(' - ')[1] || stepItem.title}</div>
                  </div>
                  {index < kypMainSteps.length - 1 && (
                    <div className={`prestige-step-line ${getLineStatus(stepItem.key)}`}>
                      <div
                        className={`prestige-step-line-fill ${getLineStatus(stepItem.key)}`}
                        style={{ width: getLineFillWidth(stepItem.key) }}
                      ></div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <div className="prestige-body">
          <div className="prestige-form-col">
            <h2 className="prestige-form-title">Know Your Property</h2>
            <p className="prestige-form-subtitle">Please enter the property details you wish to enquire about.</p>

            <div className="prestige-content">
              <form className="prestige-form" data-onboarding-form="kyp" onSubmit={(e) => e.preventDefault()}>


                {formError && (
                  <p className="kyp-form-error">
                    {formError}
                  </p>
                )}
                {activeStep === "step1" && (
                  <div className="mt-1">
                    <div className="prestige-field-group">
                      <label className="prestige-label">Type of property *</label>
                      <div className="prestige-radio-group">
                        <label className={`prestige-radio-card ${formData.typeOfProperty === "Individual" ? "selected" : ""}`}>
                          <input
                            type="radio"
                            name="typeOfProperty"
                            value="Individual"
                            checked={formData.typeOfProperty === "Individual"}
                            onChange={handleTypeProperty}
                          />
                          <div className="prestige-radio-circle">
                            <div className="prestige-radio-dot"></div>
                          </div>
                          <span className="prestige-radio-text">Individual or Multiple Owners</span>
                        </label>

                        <label className={`prestige-radio-card ${formData.typeOfProperty === "Other" ? "selected" : ""}`}>
                          <input
                            type="radio"
                            name="typeOfProperty"
                            value="Other"
                            checked={formData.typeOfProperty === "Other"}
                            onChange={handleTypeProperty}
                          />
                          <div className="prestige-radio-circle">
                            <div className="prestige-radio-dot"></div>
                          </div>
                          <span className="prestige-radio-text">Other</span>
                        </label>
                      </div>
                      {errors.typeOfProperty && <p className="gf-field-error">{errors.typeOfProperty}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label">Owner's Full Name *</label>
                      <input
                        type="text"
                        className={`prestige-input ${errors.ownerName ? "gf-error" : ""}`}
                        placeholder="Enter the property owner's full name"
                        value={formData.ownerName}
                        onChange={handleOwnerName}
                      />
                      {errors.ownerName && <p className="gf-field-error">{errors.ownerName}</p>}
                    </div>

                    {typeOfProperty === "Other" ? (
                      <div className="prestige-field-group">
                        <label className="prestige-label">Select your Property Type *</label>
                        <select
                          id="dropdown"
                          className={`prestige-select ${errors.selectedPropertyType ? "gf-error" : ""}`}
                          value={formData.selectedPropertyType}
                          onChange={handlePropertyType}
                        >
                          <option value="">Select your Property Type</option>
                          {otherList.map((mandal, index) => (
                            <option key={index} value={mandal}>
                              {mandal}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="prestige-field-group">
                      <label className="prestige-label">Property Location *</label>
                      <input
                        type="text"
                        className={`prestige-input ${errors.location ? "gf-error" : ""}`}
                        placeholder="Enter property location"

                        value={formData.location}
                        onChange={(e) =>
                          setFormData({ ...formData, location: e.target.value })
                        }
                      />
                      {errors.location && <p className="gf-field-error">{errors.location}</p>}
                    </div>

                    <div className="prestige-field-group" style={{ maxWidth: "300px" }} ref={dropdownRef}>
                      <label className="prestige-label">Year of Ownership *</label>
                      <div style={{ position: "relative" }}>
                        <button
                          type="button"
                          className={`prestige-select ${errors.ownedSince ? "gf-error" : ""}`}
                          style={{ textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                          onClick={toggleDropdown}
                        >
                          <span>{formData.ownedSince || "Select Year"}</span>
                          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>

                        {isOpen && (
                          <div
                            className="border bg-white rounded shadow position-absolute mt-1 w-100"
                            style={{ maxHeight: "180px", overflowY: "auto", zIndex: 1100 }}
                          >
                            {availableYears.map((yearOption) => (
                              <button
                                key={yearOption}
                                onClick={() => handleYearSelect(yearOption)}
                                className={`dropdown-item text-start py-2 ${formData.ownedSince === yearOption ? "bg-primary text-white" : ""}`}
                              >
                                {yearOption}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      {errors.ownedSince && <p className="gf-field-error">{errors.ownedSince}</p>}
                    </div>
                    <div className="stepper-container">
                      <div className="stepper" style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                        {(() => {
                          const visibleCategories = categories1.map((label, index) => ({
                            label,
                            originalIndex: index,
                            selectedName: textInputs[label],
                          })).filter((cat) => cat.originalIndex === activestepper || cat.selectedName);

                          return visibleCategories.map((cat, visibleIndex) => {
                            const { label, originalIndex, selectedName } = cat;
                            const isLast = visibleIndex === visibleCategories.length - 1;
                            return (
                              <React.Fragment key={originalIndex}>
                                <div
                                  className={`step ${activestepper === originalIndex ? "active" : ""} ${activestepper > originalIndex ? "completed" : ""}`}
                                  title={selectedName || "Select Department"}
                                >
                                  <div className="d-flex align-items-center mb-3">
                                    <img
                                      src={del}
                                      onClick={() => removeCategory(label)}
                                      style={{
                                        display: categories1.length === 1 ? "none" : "block",
                                      }}
                                      width={20}
                                    />
                                  </div>
                                  <div
                                    onClick={() =>
                                      handleStepClick(originalIndex, categories1[originalIndex - 1])
                                    }
                                  >
                                    <div className="circle">{visibleIndex + 1}</div>
                                    <div className="step-label" style={{ fontSize: '12px', marginTop: '4px', textAlign: 'center', color: 'var(--color-oxford-blue)' }}>
                                      {selectedName || "Select Department"}
                                    </div>
                                  </div>
                                </div>
                                {!isLast && (
                                  <div className={`step-line ${activestepper > originalIndex ? 'completed' : ''}`} />
                                )}
                              </React.Fragment>
                            );
                          });
                        })()}

                        <div className="add-category-step-wrapper">
                          <button
                            type="button"
                            className="add-category-step-btn"
                            onClick={addCategory}
                            title="Add Another Department"
                          >
                            <span className="add-icon">+</span>
                            <span className="add-text">Add Department</span>
                          </button>
                        </div>
                      </div>
                      <div className="step-content">{renderDepartmentFormat()}</div>
                      {errors.Department_wise_Documents && (
                        <span className="error-text">
                          {errors.Department_wise_Documents}
                        </span>
                      )}
                      <div className="stepper-buttons"></div>
                    </div>
                    {searchTerm && (
                      <div className="fab-button">
                        {isLoading ? (
                          <img src={loader} alt="" style={{ width: "40px" }} />
                        ) : (
                          <FaPlus
                            onClick={addDocumentSection}
                            disabled={isLoading}
                            size={20}
                          />
                        )}
                      </div>
                    )}
                    <div>
                      {formError && (
                        <p className="kyp-form-error">
                          {formError}
                        </p>
                      )}
                    </div>
                    <div className="prestige-actions">
                      <div />
                      <button type="button" disabled={DisableButton || loading} className="prestige-submit-btn" onClick={(e) => handleNext(e, "step2")}>
                        {loading ? 'Saving...' : 'Next'}
                      </button>
                    </div>
                  </div>
                )}
                {activeStep === "step2" && (
                  <div className="mt-1">
                    <div className="prestige-grid-2">
                      <div className="prestige-field-group">
                        <label className="prestige-label">Annual Tax Payment (Optional)</label>
                        <input
                          type="text"
                          className={`prestige-input ${errors.taxDetails ? "gf-error" : ""}`}
                          placeholder="Enter the annual tax payment or related details"
                          value={formData.taxDetails}
                          onChange={(e) =>
                            setFormData({ ...formData, taxDetails: e.target.value })
                          }
                        />
                        {errors.taxDetails && <p className="gf-field-error">{errors.taxDetails}</p>}
                      </div>

                      <div className="prestige-field-group">
                        <label className="prestige-label">Market Value Information *</label>
                        <input
                          type="text"
                          className={`prestige-input ${errors.marketValue ? "gf-error" : ""}`}
                          placeholder="Enter market value"
                          value={formData.marketValue}
                          onChange={(e) =>
                            setFormData({ ...formData, marketValue: e.target.value })
                          }
                        />
                        {errors.marketValue && <p className="gf-field-error">{errors.marketValue}</p>}
                      </div>

                      <div className="prestige-field-group">
                        <label className="prestige-label">Google Location (Optional)</label>
                        <input
                          type="text"
                          className={`prestige-input ${errors.googleLocation ? "gf-error" : ""}`}
                          placeholder="Enter Google Maps link"
                          value={formData.googleLocation}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              googleLocation: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="prestige-field-group">
                        <label className="prestige-label">Postal Code *</label>
                        <input
                          type="number"
                          className={`prestige-input ${errors.postalCode ? "gf-error" : ""}`}
                          placeholder="Enter the area's postal code"
                          value={formData.postalCode}
                          onChange={handlePostalCodeChange}
                        />
                        {errors.postalCode && <p className="gf-field-error">{errors.postalCode}</p>}
                      </div>
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label">Construction Details</label>
                      <textarea
                        className={`prestige-input ${errors.constructionDetails ? "gf-error" : ""}`}
                        rows="2"
                        placeholder="Enter construction details"
                        value={formData.constructionDetails}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            constructionDetails: e.target.value,
                          })
                        }
                      />
                      {errors.constructionDetails && <p className="gf-field-error">{errors.constructionDetails}</p>}
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <div className="requestProperty-doc">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={architectRef}
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv"
                            onChange={(event) => handleArchitectUpload(event)}
                          />
                          {errors.architectDoc && (
                            <span className="error-text">
                              {errors.architectDoc}
                            </span>
                          )}
                          {uploadLoadingArchitect ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Loading...</p>
                            </div>
                          ) : formData.architectDoc.length === 0 ? (
                            <div>
                              <div
                                onClick={() => architectRef.current.click()}
                                className="p-2 cursor-pointer"
                              >
                                <img src={upload} width={50} alt="Upload Icon" />
                                <p>Upload Architect Drawing</p>
                              </div>
                              <input
                                type="text"
                                className="note-input"
                                placeholder="Enter a note for the architect document"
                                value={architectNote}
                                onChange={(e) => setArchitectNote(e.target.value)}
                                style={{
                                  marginTop: "10px",
                                  padding: "5px",
                                  width: "100%",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="uploaded-docs">
                              {formData.architectDoc.map((item, index) => (
                                <div
                                  key={index}
                                  className="relative"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div
                                    className="file-actions"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={() => replaceDocument(index)}
                                      title="Replace Document"
                                    >
                                      <FaEdit
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--color-oxford-blue)",
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={() => handleArchitectDelete(index)}
                                      title="Delete Document"
                                    >
                                      <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                    </div>
                                  </div>
                                  <FilePreview
                                    url={item.url}
                                    width="100%"
                                    height="150px"
                                    style={{ border: "none" }}
                                    title={`Architect Doc ${index + 1}`}
                                  />
                                  {editingNoteIndex === index ? (
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Edit note:</strong>
                                      </p>
                                      <textarea
                                        value={editNote}
                                        onChange={(e) =>
                                          setEditNote(e.target.value)
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "8px",
                                          border: "2px solid #2196F3",
                                          borderRadius: "4px",
                                          minHeight: "60px",
                                          display: "block",
                                          marginBottom: "10px",
                                        }}
                                      />

                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                        }}
                                      >
                                        <button
                                          onClick={() =>
                                            setEditingNoteIndex(null)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          onClick={() => saveEditedNote(index)}
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    // DISPLAY MODE - Very simple
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Note:</strong>{" "}
                                        {item.note || "No note added"}
                                      </p>
                                      <button
                                        // onClick={() => startEditingNote(index)}
                                        onClick={() => startEditingNote(index)}
                                      >
                                        Edit Note
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="requestProperty-doc">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={surveyorRef}
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv"
                            onChange={(event) => handleSurveyorUpload(event)}
                          />
                          {errors.surveyorDoc && (
                            <span className="error-text">
                              {errors.surveyorDoc}
                            </span>
                          )}
                          {uploadLoadingSurveyor ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Loading...</p>
                            </div>
                          ) : formData.surveyorDoc.length === 0 ? (
                            <div>
                              <div
                                onClick={() => surveyorRef.current.click()}
                                className="p-2 cursor-pointer"
                              >
                                <img src={upload} width={50} alt="Upload Icon" />
                                <p>Upload Surveyor Drawing</p>
                              </div>
                              <input
                                type="text"
                                className="note-input"
                                placeholder="Enter a note for the surveyor document"
                                value={surveyorNote}
                                onChange={(e) => setSurveyorNote(e.target.value)}
                                style={{
                                  marginTop: "10px",
                                  padding: "5px",
                                  width: "100%",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="uploaded-docs">
                              {formData.surveyorDoc.map((item, index) => (
                                <div
                                  key={index}
                                  className="relative"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div
                                    className="file-actions"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      // onClick={() =>
                                      //   replaceSurveyorDocument(index)
                                      // }
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent click from affecting parent elements
                                        replaceSurveyorDocument(index);
                                      }}
                                      title="Replace Document"
                                    >
                                      <FaEdit
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--color-oxford-blue)",
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={() => handleSurveyorDelete(index)}
                                      title="Delete Document"
                                    >
                                      {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                      <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                    </div>
                                  </div>

                                  <FilePreview
                                    url={item.url}
                                    width="100%"
                                    height="150px"
                                    style={{ border: "none" }}
                                    title={`Surveyor Doc ${index + 1}`}
                                  />

                                  {/* {editingSurveyorIndex === index ? ( */}

                                  {editingSurveyorNoteIndex === index ? (
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Edit note:</strong>
                                      </p>
                                      <textarea
                                        value={editSurveyorNote}
                                        onChange={(e) =>
                                          setEditSurveyorNote(e.target.value)
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "8px",
                                          border: "2px solid #2196F3",
                                          borderRadius: "4px",
                                          minHeight: "60px",
                                          display: "block",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                        }}
                                      >
                                        <button
                                          onClick={() =>
                                            setEditingSurveyorNoteIndex(null)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          onClick={() =>
                                            saveEditedSurveyorNote(index)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Note:</strong>{" "}
                                        {item.note || "No note added"}
                                      </p>
                                      <button
                                        onClick={() =>
                                          startEditingSurveyorNote(index)
                                        }
                                      >
                                        Edit Note
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>


                      </div>

                      <div className="col-md-6 mb-2">

                        <div className="requestProperty-doc">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={landUseref}
                            accept=".pdf, .jpg, .png, .docx, .svg"
                            onChange={(event) => handleLandUseUpload(event)}
                          />
                          {errors.landUseDoc && (
                            <span className="error-text">
                              {errors.landUseDoc}
                            </span>
                          )}

                          {isLoading3 ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Loading...</p>
                            </div>
                          ) : formData.landUseDoc.length === 0 ? (
                            <div>
                              <div
                                onClick={() => landUseref.current.click()}
                                className="p-2 cursor-pointer"
                              >
                                <img src={upload} width={50} alt="Upload Icon" />
                                <p>Upload Land Use Document</p>
                              </div>
                              <input
                                type="text"
                                className="note-input"
                                placeholder="Enter a note for the land use document"
                                value={landUseNote}
                                onChange={(e) => setLandUseNote(e.target.value)}
                                style={{
                                  marginTop: "10px",
                                  padding: "5px",
                                  width: "100%",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="uploaded-docs">
                              {formData.landUseDoc.map((item, index) => (
                                <div
                                  key={index}
                                  className="relative"
                                  style={{ marginTop: "15px" }}
                                >
                                  <div
                                    className="file-actions"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      // onClick={() => {
                                      //   setEditingLandUse(true);
                                      //   landUseref.current.click();
                                      // }}
                                      onClick={() => {
                                        setEditingLandUse(true);
                                        setEditingLandUseIndex(index); // <--- this line is missing
                                        landUseref.current.click();
                                      }}
                                      title="Replace Document"
                                    >
                                      <FaEdit
                                        style={{
                                          fontSize: "20px",
                                          color: "var(--color-oxford-blue)",
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={() => handleLandUseDelete(index)}
                                      title="Delete Document"
                                    >
                                      {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                      <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                    </div>
                                  </div>

                                  <FilePreview
                                    url={item.url}
                                    width="100%"
                                    height="150px"
                                    style={{ border: "none" }}
                                    title={`Land Use Doc ${index + 1}`}
                                  />

                                  {editingLandUseIndex === index ? (
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Edit note:</strong>
                                      </p>
                                      <textarea
                                        value={editLandUseNote}
                                        onChange={(e) =>
                                          setEditLandUseNote(e.target.value)
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "8px",
                                          border: "2px solid #2196F3",
                                          borderRadius: "4px",
                                          minHeight: "60px",
                                          display: "block",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                        }}
                                      >
                                        <button
                                          onClick={() =>
                                            setEditingLandUseIndex(null)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          onClick={() =>
                                            saveEditedLandUseNote(index)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Note:</strong>{" "}
                                        {item.note || "No note added"}
                                      </p>
                                      <button
                                        onClick={() =>
                                          startEditingLandUseNote(index)
                                        }
                                      >
                                        Edit Note
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                      </div>
                      {/* Self Declaration (Checkbox) */}
                      <div className="mb-3 mt-2 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="selfDeclaration"
                          // Use optional chaining and default to false
                          checked={!!formData?.selfDeclaration}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setFormData(prev => ({
                              ...prev,
                              selfDeclaration: isChecked
                            }));
                          }}
                        />
                        <label className="form-check-label" htmlFor="selfDeclaration">
                          I declare that the information submitted is truthful and accurate.
                        </label>
                      </div>
                      {errors.selfDeclaration && (
                        <span className="error-text">
                          {errors.selfDeclaration}
                        </span>
                      )}
                    </div>

                    {/* Navigation Buttons */}
                    <div className="prestige-actions">
                      <button type="button" className="prestige-btn-back" onClick={(e) => handleBack(e, "step1")}>Back</button>

                      <button
                        type="button"
                        className="prestige-submit-btn"
                        disabled={uploadLoadingArchitect || uploadLoadingSurveyor || isLoading3 || loading}
                        onClick={(e) => handleNext(e, "step3")}
                      >
                        {loading ? 'Saving...' : 'Next'}
                      </button>
                    </div>
                  </div>
                )}
                {activeStep === "step3" && (
                  <div className="mt-1">
                    <div className="prestige-form-subtitle mb-3">
                      <strong>Neighbour Details</strong>
                    </div>

                    {/* Neighbour Details - all directions listed in a 2x2 grid */}
                    <div className="neighbour-compass-grid">
                      {formData.neighbourDetails.map((item, index) => (
                        <div key={item.direction} className="neighbour-name-card">
                          <div className="neighbour-name-card-header mb-2 d-flex justify-content-between align-items-center">
                            <span className="neighbour-dir-badge">
                              {item.direction.charAt(0).toUpperCase() + item.direction.slice(1)} Neighbour
                            </span>
                          </div>

                          <div className="prestige-field-group mb-2">
                            <label className="prestige-label" style={{ fontSize: '11px', fontWeight: '600' }}>
                              Name *
                            </label>
                            <input
                              type="text"
                              className={`prestige-input prestige-input-sm ${errors[`neighbour_${item.direction}`] ? 'gf-error' : ''}`}
                              placeholder={`Enter name`}
                              value={item.name}
                              onChange={(e) => {
                                const updatedNeighbours = [...formData.neighbourDetails];
                                updatedNeighbours[index].name = e.target.value;
                                setFormData({ ...formData, neighbourDetails: updatedNeighbours });
                              }}
                              style={{ height: '32px', fontSize: '12px' }}
                            />
                            {errors[`neighbour_${item.direction}`] && (
                              <p className="gf-field-error" style={{ fontSize: '10px' }}>{errors[`neighbour_${item.direction}`]}</p>
                            )}
                          </div>

                          {/* Neighbour Document Upload */}
                          <div className="neighbour-doc-section">
                            <h6 className="neighbour-doc-title">
                              Documents
                            </h6>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              ref={(el) => (uploadRefs.current[item.direction] = el)}
                              accept=".pdf, .jpg, .png, .docx, .svg"
                              onChange={(e) =>
                                handleNeighbourDocUpload(
                                  e,
                                  item.direction,
                                  index,
                                  editDocIndex[item.direction] ?? null
                                )
                              }
                            />

                            {errors.neighbourDetails &&
                              typeof errors.neighbourDetails === "object" &&
                              errors.neighbourDetails[item.direction] && (
                                <span className="error-text" style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>
                                  {errors.neighbourDetails[item.direction]}
                                </span>
                              )}

                            {neighbourDirectionLoading[item.direction] ? (
                              <div className="loader-container d-flex flex-column align-items-center py-2">
                                <img src={loader} alt="Loading..." style={{ width: "24px" }} />
                                <p className="text-muted mb-0" style={{ fontSize: '10px' }}>Uploading...</p>
                              </div>
                            ) : (
                              <>
                                {/* Existing documents - 4 per row */}
                                {(item.document || []).length > 0 && (
                                  <div className="neighbour-docs-grid">
                                    {item.document.map((doc, docIdx) => (
                                      <div
                                        key={`${item.direction}-${doc.url || 'doc'}-${docIdx}`}
                                        className="neighbour-doc-card"
                                      >
                                        <div className="neighbour-doc-actions">
                                          <span
                                            onClick={() => {
                                              setEditDocIndex((prev) => ({ ...prev, [item.direction]: docIdx }));
                                              uploadRefs.current[item.direction].click();
                                            }}
                                            title="Edit"
                                            className="neighbour-doc-action-btn"
                                          >
                                            <FaEdit size={8} />
                                          </span>
                                          <span
                                            onClick={() => handleNeighbourDocDelete(item.direction, docIdx)}
                                            title="Delete"
                                            className="neighbour-doc-action-btn delete"
                                          >
                                            ✕
                                          </span>
                                        </div>
                                        <FilePreview
                                          url={doc.url}
                                          width="100%"
                                          height="60px"
                                          style={{ border: 'none' }}
                                          title={`${item.direction} Doc ${docIdx + 1}`}
                                          showPreview={false}
                                        />
                                        <div className="neighbour-doc-note">
                                          <span className="neighbour-doc-note-label">Note: </span>
                                          <span>{doc.note || 'No note'}</span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* Upload placeholder */}
                                <div
                                  className="neighbour-upload-placeholder"
                                  onClick={() => uploadRefs.current[item.direction].click()}
                                >
                                  <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
                                    <img src={upload} width={16} alt="Upload Icon" />
                                    <span style={{ fontSize: '11px', fontWeight: '500' }}>Upload document</span>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ fontSize: '10px', padding: '2px 6px', height: '24px' }}
                                    placeholder="Enter note before upload"
                                    value={tempNote[item.direction] || ""}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) =>
                                      setTempNote({ ...tempNote, [item.direction]: e.target.value })
                                    }
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selfDeclaration"
                        checked={formData.selfDeclaration2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            selfDeclaration2: e.target.checked,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="selfDeclaration"
                      >
                        If the property is sold, either partially or in full, the subscription to Docity will be cancelled.
                      </label>

                      <br />
                      {errors.selfDeclaration2 && (
                        <span className="error-text">
                          {errors.selfDeclaration2}
                        </span>
                      )}
                    </div>

                    <div className="prestige-actions">
                      <button type="button" className="prestige-btn-back" onClick={(e) => handleBack(e, "step2")}>Back</button>

                      <button
                        type="button"
                        className="prestige-submit-btn"
                        disabled={loading}
                        onClick={(e) => handleNext(e, "step4")}
                      >
                        {loading ? 'Saving...' : 'Next'}
                      </button>
                    </div>
                  </div>
                )}
                {activeStep === "step4" && (
                  <div>
                    <div>
                      <div className="label">
                        <p>Ownership change details</p>
                      </div>
                      <div className="p-2">

                        <div className="row">
                          <div className="col-md-3"></div>
                          <div className="col-md-6">
                            <div className="requestProperty-doc ">
                              <input
                                type="file"
                                style={{ display: "none" }}
                                ref={futureOwnershipRef}
                                accept=".pdf, .jpg, .png, .doc, .svg"
                                onChange={(e) => handleFutureOwnershipUpload(e)}
                              />
                              {errors.futureOwnershipDoc && (
                                <span className="error-text">
                                  {errors.futureOwnershipDoc}
                                </span>
                              )}
                              {isLoading8 ? (
                                <div className="loader-container">
                                  <img src={loader} alt="Loading..." />
                                  <p>Uploading...</p>
                                </div>
                              ) : !(
                                formData.futureOwnershipDoc &&
                                formData.futureOwnershipDoc.url
                              ) ? (
                                <div>
                                  <div
                                    className="p-2 cursor-pointer"
                                    onClick={() => futureOwnershipRef.current.click()}
                                  >
                                    <img src={upload} width={50} alt="Upload Icon" />
                                    <p>Upload Future Ownership Document</p>
                                  </div>
                                  <input
                                    type="text"
                                    className="note-input"
                                    placeholder="Enter note for future ownership document"
                                    value={futureOwnershipNote}
                                    onChange={(e) =>
                                      setFutureOwnershipNote(e.target.value)
                                    }
                                    style={{
                                      marginTop: "10px",
                                      padding: "5px",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="relative">
                                  <div
                                    className="file-actions"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={() => {
                                        setEditingFutureOwnership(true);
                                        futureOwnershipRef.current.click();
                                      }}
                                      title="Edit"
                                    >
                                      <FaEdit
                                        style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                      />
                                    </div>

                                    <div
                                      className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                      onClick={handleFutureOwnershipDelete}
                                      title="Delete"
                                    >
                                      <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                    </div>
                                  </div>

                                  <FilePreview
                                    url={formData.futureOwnershipDoc.url}
                                    width="100%"
                                    height="150px"
                                    style={{ border: "none" }}
                                    title="Future Ownership Viewer"
                                    onLoad={onLoad}
                                    onError={onError}
                                  />

                                  {hasError && (
                                    <p className="error-message">
                                      Failed to load document
                                    </p>
                                  )}

                                  {editingFutureOwnershipNote ? (
                                    <div
                                      style={{ marginTop: "10px", margin: "10px" }}
                                    >
                                      <p>
                                        <strong>Edit note:</strong>
                                      </p>
                                      <textarea
                                        value={editFutureOwnershipNote}
                                        onChange={(e) =>
                                          setEditFutureOwnershipNote(e.target.value)
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "8px",
                                          border: "2px solid #2196F3",
                                          borderRadius: "4px",
                                          minHeight: "60px",
                                          display: "block",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                        }}
                                      >
                                        <button
                                          onClick={() =>
                                            setEditingFutureOwnershipNote(false)
                                          }
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          onClick={saveEditedFutureOwnershipNote}
                                          className="d-flex justify-content-center m-1 gap-2"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mt-2 mb-2">
                                      <p>
                                        <strong>Note:</strong>{" "}
                                        {formData.futureOwnershipDoc.note ||
                                          "No note added"}
                                      </p>
                                      <button
                                        onClick={startEditingFutureOwnershipNote}
                                      >
                                        Edit Note
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-3"></div>
                        </div>

                        <div className="mb-3">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={(e) =>
                              setFormData({ ...formData, email: e.target.value })
                            }
                          />
                          {errors.email && (
                            <span className="error-text">{errors.email}</span>
                          )}
                        </div>


                        <div className="mb-3">
                          <label><strong>Is this form filled by:</strong></label><br />

                          <div>
                            <input
                              type="checkbox"
                              className="form-check-input m-1"
                              checked={formData.filledBy === "owner"}
                              onChange={() =>
                                setFormData({ ...formData, filledBy: "owner" })
                              }
                            />
                            <label className="form-check-label">
                              Owner
                            </label>
                          </div>

                          <div>
                            <input
                              type="checkbox"
                              className="form-check-input m-1"
                              checked={formData.filledBy === "other"}
                              onChange={() =>
                                setFormData({ ...formData, filledBy: "other" })
                              }
                            />
                            <label> Other
                            </label>
                          </div>


                          {errors.filledBy && (
                            <span className="error-text">{errors.filledBy}</span>
                          )}
                        </div>
                        {formData.filledBy === "other" && (
                          <div>
                            <div className="row">
                              <div className="col md-6">
                                <div>
                                  <label>Age</label>
                                  <input
                                    type="number"
                                    placeholder="Age"
                                    className="form-control"
                                    value={formData.otherPersonDetails.age}
                                    min="0"
                                    max="100"
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        otherPersonDetails: {
                                          ...formData.otherPersonDetails,
                                          age: e.target.value
                                        }
                                      })
                                    }
                                    onInput={(e) => {
                                      if (e.target.value.length > 3) {
                                        e.target.value = e.target.value.slice(0, 3);
                                      }
                                    }}
                                  />
                                  {errors.otherPersonAge && (
                                    <span className="error-text">{errors.otherPersonAge}</span>
                                  )}
                                </div>

                              </div>
                              <div className="col-md-6">
                                <div>
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    placeholder="Email"
                                    className="form-control"
                                    value={formData.otherPersonDetails.email}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        otherPersonDetails: {
                                          ...formData.otherPersonDetails,
                                          email: e.target.value
                                        }
                                      })
                                    }
                                  />
                                  {errors.otherPersonEmail && (
                                    <span className="error-text">{errors.otherPersonEmail}</span>
                                  )}
                                </div>
                                <div>
                                  <label>DOB</label>
                                  <input
                                    type="date"
                                    max={maxDobDate}
                                    value={formData.otherPersonDetails.dob}
                                    className="form-control"
                                    onChange={(e) => {
                                      let value = e.target.value;
                                      const parts = value.split('-');
                                      if (parts[0] && parts[0].length > 4) {
                                        parts[0] = parts[0].slice(0, 4);
                                        value = parts.join('-');
                                      }

                                      setFormData({
                                        ...formData,
                                        otherPersonDetails: {
                                          ...formData.otherPersonDetails,
                                          dob: value
                                        }
                                      })
                                    }}
                                  />
                                  {errors.otherPersonDob && (
                                    <span className="error-text">{errors.otherPersonDob}</span>
                                  )}
                                </div>


                              </div>
                            </div>



                            <div>
                              <label>Address</label>
                              <input
                                type="text"
                                placeholder="Address"
                                className="form-control"
                                value={formData.otherPersonDetails.address}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    otherPersonDetails: {
                                      ...formData.otherPersonDetails,
                                      address: e.target.value
                                    }
                                  })
                                }
                              />
                              {errors.otherPersonAddress && (
                                <span className="error-text">{errors.otherPersonAddress}</span>
                              )}

                            </div>

                          </div>
                        )}

                        <br />
                        <div className="mb-3 form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="selfDeclaration"
                            //   checked={selfDeclaration}
                            //   onChange={(e) => setSelfDeclaration(e.target.checked)}
                            checked={formData.selfDeclaration3}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                selfDeclaration3: e.target.checked,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="selfDeclaration"
                          >
                            I confirm that the information provided above is accurate and truthful.
                          </label>
                          <br></br>
                          {errors.selfDeclaration3 && (
                            <span className="error-text">
                              {errors.selfDeclaration3}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="prestige-actions">
                      <button type="button" className="prestige-btn-back" onClick={(e) => handleBack(e, "step3")}>Back</button>
                      <button type="button" className="prestige-submit-btn" disabled={isLoading8 || loading} onClick={(e) => handleNext(e, "step5")}>{loading ? 'Saving...' : 'Next'}</button>
                    </div>
                  </div>
                )}
                {activeStep === "step5" && (
                  <div className="mt-3 p-2">
                    <div className="prestige-form-subtitle mb-4">
                      <strong>Location Attributes</strong>
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label" htmlFor="amsl">AMSL (Average Mean Sea Level)</label>
                      <input
                        type="text"
                        className={`prestige-input ${errors.amsl ? "gf-error" : ""}`}
                        id="amsl"
                        value={formData.amsl}
                        onChange={(e) =>
                          setFormData({ ...formData, amsl: e.target.value })
                        }
                        placeholder="Enter AMSL value"
                      />
                      {errors.amsl && <p className="gf-field-error">{errors.amsl}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label" htmlFor="roadDetails">Road Information</label>
                      <textarea
                        className={`prestige-input ${errors.roadDetails ? "gf-error" : ""}`}
                        id="roadDetails"
                        value={formData.roadDetails}
                        onChange={(e) =>
                          setFormData({ ...formData, roadDetails: e.target.value })
                        }
                        placeholder="Enter road information"
                      ></textarea>
                      {errors.roadDetails && <p className="gf-field-error">{errors.roadDetails}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label" htmlFor="sro">SRO (Sub-Registrar Office)</label>
                      <input
                        type="text"
                        className={`prestige-input ${errors.sro ? "gf-error" : ""}`}
                        id="sro"
                        value={formData.sro}
                        onChange={(e) =>
                          setFormData({ ...formData, sro: e.target.value })
                        }
                        placeholder="Enter SRO details"
                      />
                      {errors.sro && <p className="gf-field-error">{errors.sro}</p>}
                    </div>

                    <div className="prestige-field-group">
                      <label className="prestige-label" htmlFor="po">Post Office</label>
                      <input
                        type="text"
                        className={`prestige-input ${errors.pd ? "gf-error" : ""}`}
                        id="pd"
                        value={formData.pd}
                        onChange={(e) =>
                          setFormData({ ...formData, pd: e.target.value })
                        }
                        placeholder="Enter Post Office details"
                      />
                      {errors.pd && <p className="gf-field-error">{errors.pd}</p>}
                    </div>

                    <div className="row">
                      <div className="col-md-3"></div>
                      <div className="col-md-6">
                        <div className="requestProperty-doc mb-3">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={neighbourRef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleDrawingDocUpload(e)}
                          />
                          {errors.drawings && (
                            <span className="error-text">{errors.drawings}</span>
                          )}

                          {isLoading11 ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : !formData.drawings ? (
                            <div>
                              <div className="p-2 cursor-pointer">
                                <img
                                  src={upload}
                                  width={50}
                                  alt="Upload Icon"
                                  onClick={() => neighbourRef.current.click()}
                                />
                                <p onClick={() => neighbourRef.current.click()}>
                                  Upload Architectural Plan
                                </p>
                              </div>
                              <div>
                                <input
                                  type="text"
                                  className="note-input"
                                  placeholder="Enter note for architectural plan"
                                  value={drawingNote}
                                  onChange={(e) => setDrawingNote(e.target.value)}
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="relative">
                              <div
                                className="file-actions"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "10px",
                                }}
                              >
                                <div
                                  className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                  onClick={() => {
                                    setEditingDrawing(true);
                                    neighbourRef.current.click();
                                  }}
                                  title="Edit"
                                >
                                  <FaEdit
                                    style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                  />
                                </div>

                                <div
                                  className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                  onClick={handleDrawingDocDelete}
                                  title="Delete"
                                >
                                  {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                  <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                </div>
                              </div>

                              <FilePreview
                                url={formData.drawings.url}
                                width="100%"
                                height="150px"
                                style={{ border: "none" }}
                                title="Drawing Viewer"
                                onLoad={onLoad}
                                onError={onError}
                              />
                              {hasError && (
                                <p className="error-message">
                                  Failed to load document
                                </p>
                              )}

                              {editingDrawingNote ? (
                                <div style={{ marginTop: "10px", margin: "10px" }}>
                                  <p>
                                    <strong>Edit note:</strong>
                                  </p>
                                  <textarea
                                    value={editDrawingNote}
                                    onChange={(e) =>
                                      setEditDrawingNote(e.target.value)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: "8px",
                                      border: "2px solid #2196F3",
                                      borderRadius: "4px",
                                      minHeight: "60px",
                                      display: "block",
                                      marginBottom: "10px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: "10px",
                                    }}
                                  >
                                    <button
                                      onClick={() => setEditingDrawingNote(false)}
                                      className="d-flex justify-content-center m-1 gap-2"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={saveEditedDrawingNote}
                                      className="d-flex justify-content-center m-1 gap-2"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-2 mb-2">
                                  <p>
                                    <strong>Note:</strong>{" "}
                                    {formData.drawings.note || "No note added"}
                                  </p>
                                  <button onClick={startEditingDrawingNote}>
                                    Edit Note
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3"></div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="legalStatus">Legal Status</label>
                      <select
                        className="form-control"
                        id="legalStatus"
                        value={formData.legalStatus}
                        onChange={(e) =>
                          setFormData({ ...formData, legalStatus: e.target.value })
                        }
                      >
                        <option value="">Select</option>
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Disputed">Disputed</option>
                      </select>
                      {errors.legalStatus && (
                        <span className="error-text">{errors.legalStatus}</span>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="financialStatus">Financial Status</label>
                      <select
                        className="form-control"
                        id="financialStatus"
                        value={formData.financialStatus}
                        //   onChange={(e) => setFinancialStatus(e.target.value)}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            financialStatus: e.target.value,
                          })
                        }
                      >
                        <option value="">Select</option>
                        <option value="Bank Loan">Bank Loan</option>
                        <option value="Mortgage">Mortgage</option>
                        <option value="Cleared">Cleared</option>
                      </select>
                      {errors.financialStatus && (
                        <span className="error-text">{errors.financialStatus}</span>
                      )}
                    </div>
                    {[
                      {
                        id: "consentSharing",
                        label:
                          "Authorization to share information with nationalized banks.",
                      },
                      {
                        id: "consentSurvey",
                        label:
                          "Permission to share details with government authorities and the Survey of India.",
                      },
                      {
                        id: "futureTitleGuarantee",
                        label:
                          "Approval for submission towards future Title Guarantee assessment.",
                      },
                      {
                        id: "internationalGovernance",
                        label:
                          "Consent for submission under international regulatory frameworks.",
                      },
                    ].map((item) => (
                      <div key={item.id} className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={item.id}
                          checked={formData[item.id]}
                          onChange={(e) =>
                            setFormData({ ...formData, [item.id]: e.target.checked })
                          }
                        />
                        <label className="form-check-label" htmlFor={item.id}>
                          {item.label}
                        </label>
                      </div>
                    ))}
                    {errors.checkboxes && (
                      <span className="error-text">{errors.checkboxes}</span>
                    )}
                    <div className="prestige-actions">
                      <button type="button" className="prestige-btn-back" onClick={(e) => handleBack(e, "step4")}>Back</button>
                      <button type="button" className="prestige-submit-btn" disabled={isLoading11 || loading} onClick={(e) => handleNext(e, "step6")}>{loading ? 'Saving...' : 'Next'}</button>
                    </div>


                  </div>
                )}
                {activeStep === "step6" && (
                  <div>
                    <div className="mt-2 p-2">{/* <p>content</p> */}</div>
                    <div className="label">
                      <p>Building and Construction Details</p>
                    </div>

                    <div className="row">
                      <div className="col-md-3"></div>
                      <div className="col-md-6">
                        <div className="requestProperty-doc mb-2">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={ownerPhotoRef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleOwnerPhotoUpload(e)}
                          />
                          {errors.ownerPhoto && (
                            <span className="error-text">{errors.ownerPhoto}</span>
                          )}
                          {/* {errors.firmType && (
                  <span className="error-text">{errors.firmType}</span>
                )} */}

                          {isLoadingowner ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : // ) : formData.ownerPhoto.length===0 ? (
                            !(formData.ownerPhoto && formData.ownerPhoto.url) ? (
                              <div>
                                <div
                                  className="p-2 cursor-pointer"
                                  onClick={() => ownerPhotoRef.current.click()}
                                >
                                  <img src={upload} width={50} alt="Upload Icon" />
                                  <p>Upload Ownership Document</p>
                                </div>
                                <input
                                  type="text"
                                  className="note-input"
                                  placeholder="Enter note for ownership document"
                                  value={ownerPhotoNote}
                                  onChange={(e) => setOwnerPhotoNote(e.target.value)}
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="relative">
                                <div
                                  className="file-actions"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {/* Edit */}
                                  <div
                                    className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                      setEditingOwnerPhoto(true);
                                      ownerPhotoRef.current.click();
                                    }}
                                    title="Edit"
                                  >
                                    <FaEdit
                                      style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                    />
                                  </div>

                                  {/* Delete */}
                                  <div
                                    className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={handleOwnerPhotoDelete}
                                    title="Delete"
                                  >
                                    {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                    <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                  </div>
                                </div>

                                <FilePreview
                                  url={formData.ownerPhoto.url}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "none" }}
                                  title="Owner Document Viewer"
                                  onLoad={onLoad3}
                                  onError={onError}
                                />
                                {hasError && (
                                  <p className="error-message">
                                    Failed to load document
                                  </p>
                                )}

                                {/* Note Section */}
                                {editingOwnerPhotoNote ? (
                                  <div style={{ marginTop: "10px", margin: "10px" }}>
                                    <p>
                                      <strong>Edit note:</strong>
                                    </p>
                                    <textarea
                                      value={editOwnerPhotoNote}
                                      onChange={(e) =>
                                        setEditOwnerPhotoNote(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        border: "2px solid #2196F3",
                                        borderRadius: "4px",
                                        minHeight: "60px",
                                        display: "block",
                                        marginBottom: "10px",
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => setEditingOwnerPhotoNote(false)}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={saveEditedOwnerPhotoNote}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="mt-2 mb-2">
                                    <p>
                                      <strong>Note:</strong>{" "}
                                      {formData.ownerPhoto.note || "No note added"}
                                    </p>
                                    <button onClick={startEditingOwnerPhotoNote}>
                                      Edit Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-3"></div>
                    </div>
                    <div className="mb-3">
                      <label>Firm Registration Certificate</label>
                      <select
                        className="form-select"
                        value={formData.firmType}
                        onChange={(e) =>
                          setFormData({ ...formData, firmType: e.target.value })
                        }
                      >
                        <option value="">Select Type</option>
                        <option value="LLP">LLP</option>
                        <option value="Pvt Ltd">Pvt Ltd</option>
                        <option value="Public Ltd">Public Ltd</option>
                      </select>
                      {errors.firmType && (
                        <span className="error-text">{errors.firmType}</span>
                      )}
                    </div>

                    <div className="mb-3">
                      <label>Additional Information(Optional)</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter details"
                        value={formData.otherFirmDetail}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            otherFirmDetail: e.target.value,
                          })
                        }
                      />
                      {errors.otherFirmDetail && (
                        <span className="error-text">{errors.otherFirmDetail}</span>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md-6">

                        <div className="requestProperty-doc mb-2">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={mainElevationRef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleMainElevationUpload(e)}
                          />
                          {errors.mainElevation && (
                            <span className="error-text">{errors.mainElevation}</span>
                          )}

                          {uploadLoadingMainElevation ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : // ) : formData.mainElevation.length===0 ? (
                            !(formData.mainElevation && formData.mainElevation.url) ? (
                              <div>
                                <div
                                  className="p-2 cursor-pointer"
                                  onClick={() => mainElevationRef.current.click()}
                                >
                                  <img src={upload} width={50} alt="Upload Icon" />
                                  <p>Upload Front Elevation</p>
                                </div>

                                <input
                                  type="text"
                                  className="note-input"
                                  placeholder="Enter a note for the front elevation"
                                  value={mainElevationNote}
                                  onChange={(e) => {
                                    setMainElevationNote(e.target.value);
                                  }}
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="relative">
                                <div
                                  className="file-actions"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {/* Edit */}
                                  <div
                                    className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                      setEditingMainElevation(true);
                                      mainElevationRef.current.click();
                                    }}
                                    title="Edit"
                                  >
                                    <FaEdit
                                      style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                    />
                                  </div>

                                  {/* Delete */}
                                  <div
                                    className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={handleMainElevationDelete}
                                    title="Delete"
                                  >
                                    {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                    <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                  </div>
                                </div>

                                <FilePreview
                                  url={formData.mainElevation.url}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "none" }}
                                  title="Main Elevation Viewer"
                                  onLoad={onLoad3}
                                  onError={onError}
                                />
                                {hasError && (
                                  <p className="error-message">
                                    Failed to load document
                                  </p>
                                )}

                                {/* Note Section */}
                                {editingMainElevationNote ? (
                                  <div style={{ marginTop: "10px", margin: "10px" }}>
                                    <p>
                                      <strong>Edit note:</strong>
                                    </p>
                                    <textarea
                                      value={editMainElevationNote}
                                      onChange={(e) =>
                                        setEditMainElevationNote(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        border: "2px solid #2196F3",
                                        borderRadius: "4px",
                                        minHeight: "60px",
                                        display: "block",
                                        marginBottom: "10px",
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          setEditingMainElevationNote(false)
                                        }
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={saveEditedMainElevationNote}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="m-2">
                                    <p>
                                      <strong>Note:</strong>{" "}
                                      {formData.mainElevation.note || "No note added"}
                                    </p>
                                    <button onClick={startEditingMainElevationNote}>
                                      Edit Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="requestProperty-doc mb-2">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={otherSideARef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleOtherSideAUpload(e)}
                          />
                          {errors.otherSideA && (
                            <span className="error-text">{errors.otherSideA}</span>
                          )}

                          {isLoading3 ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : // ) : formData.otherSideA.length===0 ? (
                            !(formData.otherSideA && formData.otherSideA.url) ? (
                              <div>
                                <div
                                  className="p-2 cursor-pointer"
                                  onClick={() => otherSideARef.current.click()}
                                >
                                  <img src={upload} width={50} alt="Upload Icon" />
                                  <p>Upload Left Side View</p>
                                </div>
                                <input
                                  type="text"
                                  className="note-input"
                                  placeholder="Enter a note for left side view"
                                  value={otherSideANote}
                                  onChange={(e) => setOtherSideANote(e.target.value)}
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="relative">
                                <div
                                  className="file-actions"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {/* Edit */}
                                  <div
                                    className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                      setEditingOtherSideA(true);
                                      otherSideARef.current.click();
                                    }}
                                    title="Edit"
                                  >
                                    <FaEdit
                                      style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                    />
                                  </div>

                                  {/* Delete */}
                                  <div
                                    className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={handleOtherSideADelete}
                                    title="Delete"
                                  >
                                    {/* <FaTrashAlt style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }} /> */}
                                    <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                  </div>
                                </div>

                                <FilePreview
                                  url={formData.otherSideA.url}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "none" }}
                                  title="Other Side A Viewer"
                                  onLoad={onLoad3}
                                  onError={onError}
                                />
                                {hasError && (
                                  <p className="error-message">
                                    Failed to load document
                                  </p>
                                )}

                                {/* Note Section */}
                                {editingOtherSideANote ? (
                                  <div style={{ marginTop: "10px", margin: "10px" }}>
                                    <p>
                                      <strong>Edit note:</strong>
                                    </p>
                                    <textarea
                                      value={editOtherSideANote}
                                      onChange={(e) =>
                                        setEditOtherSideANote(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        border: "2px solid #2196F3",
                                        borderRadius: "4px",
                                        minHeight: "60px",
                                        display: "block",
                                        marginBottom: "10px",
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => setEditingOtherSideANote(false)}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={saveEditedOtherSideANote}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="m-2">
                                    <p>
                                      <strong>Note:</strong>{" "}
                                      {formData.otherSideA.note || "No note added"}
                                    </p>
                                    <button onClick={startEditingOtherSideANote}>
                                      Edit Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="">

                      </div>
                      <div className="col-md-6">
                        <div className="requestProperty-doc mb-2">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={otherSideBRef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleOtherSideBUpload(e)}
                          />
                          {errors.otherSideB && (
                            <span className="error-text">{errors.otherSideB}</span>
                          )}

                          {isLoadingOtherSideB ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : // ) : formData.otherSideB.length===0 ? (
                            !(formData.otherSideB && formData.otherSideB.url) ? (
                              <div>
                                <div
                                  className="p-2 cursor-pointer"
                                  onClick={() => otherSideBRef.current.click()}
                                >
                                  <img src={upload} width={50} alt="Upload Icon" />
                                  <p>Upload Right Side View</p>
                                </div>
                                <input
                                  type="text"
                                  className="note-input"
                                  placeholder="Enter a note for right side view"
                                  value={otherSideBNote}
                                  onChange={(e) => setOtherSideBNote(e.target.value)}
                                  style={{
                                    marginTop: "10px",
                                    padding: "5px",
                                    width: "100%",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="relative">
                                <div
                                  className="file-actions"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {/* Edit */}
                                  <div
                                    className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                      setEditingOtherSideB(true);
                                      otherSideBRef.current.click();
                                    }}
                                    title="Edit"
                                  >
                                    <FaEdit
                                      style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                    />
                                  </div>

                                  {/* Delete */}
                                  <div
                                    className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={handleOtherSideBDelete}
                                    title="Delete"
                                  >
                                    <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                  </div>
                                </div>

                                <FilePreview
                                  url={formData.otherSideB.url}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "none" }}
                                  title="Other Side B Viewer"
                                  onLoad={onLoad3}
                                  onError={onError}
                                />
                                {hasError && (
                                  <p className="error-message">
                                    Failed to load document
                                  </p>
                                )}

                                {/* Note Section */}
                                {editingOtherSideBNote ? (
                                  <div style={{ marginTop: "10px", margin: "10px" }}>
                                    <p>
                                      <strong>Edit note:</strong>
                                    </p>
                                    <textarea
                                      value={editOtherSideBNote}
                                      onChange={(e) =>
                                        setEditOtherSideBNote(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        border: "2px solid #2196F3",
                                        borderRadius: "4px",
                                        minHeight: "60px",
                                        display: "block",
                                        marginBottom: "10px",
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => setEditingOtherSideBNote(false)}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={saveEditedOtherSideBNote}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="m-2">
                                    <p>
                                      <strong>Note:</strong>{" "}
                                      {formData.otherSideB.note || "No note added"}
                                    </p>

                                    <button onClick={startEditingOtherSideBNote}>
                                      Edit Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-6">

                        <div className="requestProperty-doc mb-2">
                          <input
                            type="file"
                            style={{ display: "none" }}
                            ref={otherSideCRef}
                            accept=".pdf, .jpg, .png, .doc, .svg"
                            onChange={(e) => handleOtherSideCUpload(e)}
                          />
                          {errors.otherSideC && (
                            <span className="error-text">{errors.otherSideC}</span>
                          )}

                          {isLoading5 ? (
                            <div className="loader-container">
                              <img src={loader} alt="Loading..." />
                              <p>Uploading...</p>
                            </div>
                          ) : // ) : formData.otherSideC.length===0 ? (
                            !(formData.otherSideC && formData.otherSideC.url) ? (
                              <div>
                                <div
                                  className="p-2 cursor-pointer"
                                  onClick={() => otherSideCRef.current.click()}
                                >
                                  <img src={upload} width={50} alt="Upload Icon" />
                                  <p>Upload Rear Side View</p>
                                </div>
                                <div>
                                  <input
                                    type="text"
                                    className="note-input"
                                    placeholder="Enter a note for rear side view"
                                    value={otherSideCNote}
                                    onChange={(e) => setOtherSideCNote(e.target.value)}
                                    style={{
                                      marginTop: "10px",
                                      padding: "5px",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div className="relative">
                                <div
                                  className="file-actions"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    className="absolute top-2 left-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={() => {
                                      setEditingOtherSideC(true);
                                      otherSideCRef.current.click();
                                    }}
                                    title="Edit"
                                  >
                                    <FaEdit
                                      style={{ fontSize: "20px", color: "var(--color-oxford-blue)" }}
                                    />
                                  </div>

                                  <div
                                    className="absolute top-2 right-2 z-10 bg-white p-1 rounded-full shadow cursor-pointer hover:bg-gray-100"
                                    onClick={handleDeleteOtherSideC}
                                    title="Delete"
                                  >
                                    <FaTrashAlt style={{ color: "var(--ds-danger-ink, #ef4444)" }} />
                                  </div>
                                </div>

                                <FilePreview
                                  url={formData.otherSideC.url}
                                  width="100%"
                                  height="150px"
                                  style={{ border: "none" }}
                                  title="Other Side C Viewer"
                                  onLoad={onLoad3}
                                  onError={onError}
                                />
                                {hasError && (
                                  <p className="error-message">
                                    Failed to load document
                                  </p>
                                )}
                                {editingOtherSideCNote ? (
                                  <div style={{ marginTop: "10px", margin: "10px" }}>
                                    <p>
                                      <strong>Edit note:</strong>
                                    </p>
                                    <textarea
                                      value={editOtherSideCNote}
                                      onChange={(e) =>
                                        setEditOtherSideCNote(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        border: "2px solid #2196F3",
                                        borderRadius: "4px",
                                        minHeight: "60px",
                                        display: "block",
                                        marginBottom: "10px",
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <button
                                        onClick={() => setEditingOtherSideCNote(false)}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        onClick={saveEditedOtherSideCNote}
                                        className="d-flex justify-content-center m-1 gap-2"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="m-2">
                                    <p>
                                      <strong>Note:</strong>{" "}
                                      {formData.otherSideC.note || "No note added"}
                                    </p>
                                    <button onClick={startEditingOtherSideCNote}>
                                      Edit Note
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 position-relative" style={{ maxWidth: "300px" }} ref={dropdownRef}>
                      <label className="form-label fw-semibold">Building Age</label>
                      <br />
                      <button
                        type="button"
                        className="custom-select-button"
                        onClick={toggleDropdown}
                      >
                        <span className="m-1">{formData.buildingAge || "Select Year"}</span>
                        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </button>

                      {isOpen && (
                        <div
                          className="border bg-white rounded shadow position-absolute mt-1 w-100"
                          style={{ maxHeight: "180px", overflowY: "auto", zIndex: 1100 }}
                        >
                          {availableYears.map((yearOption) => (
                            <button
                              key={yearOption}
                              onClick={() => handleYearSelectbuildingage(yearOption)}
                              className={`dropdown-item text-start py-2 ${formData.buildingAge === yearOption ? "bg-primary text-white" : ""
                                }`}
                            >
                              {yearOption}
                            </button>
                          ))}
                        </div>
                      )}

                      {errors.buildingAge && (
                        <div className="text-danger small mt-1">{errors.buildingAge}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label>Building Details/Description</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Enter details"
                        value={formData.buildingDescription}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            buildingDescription: e.target.value,
                          })
                        }
                      ></textarea>
                      {errors.buildingDescription && (
                        <span className="error-text">
                          {errors.buildingDescription}
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>Architect Details</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter details"
                        value={formData.architectDetails}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            architectDetails: e.target.value,
                          })
                        }
                      />
                      {errors.architectDetails && (
                        <span className="error-text">{errors.architectDetails}</span>
                      )}
                    </div>

                    <div className="mb-3">
                      <label>Civil Engineer Details</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter details"
                        value={formData.civilEngineerDetails}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            civilEngineerDetails: e.target.value,
                          })
                        }
                      />
                      {errors.civilEngineerDetails && (
                        <span className="error-text">
                          {errors.civilEngineerDetails}
                        </span>
                      )}
                    </div>
                    <div className="container mt-3">
                      {/* Consultants Section */}
                      <div className="mb-4">
                        <label className="form-label fw-bold">Consultants</label>

                        {["Legal Consultants", "CA"].map((consultant) => (
                          <div className="form-check" key={consultant}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={consultant.toLowerCase().replace(/\s+/g, "-")}
                              checked={formData.consultants.includes(consultant)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setconsultantType('')
                                  setFormData({
                                    ...formData,
                                    consultantType: "",
                                    consultants: [...formData.consultants, consultant],
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    consultants: formData.consultants.filter((c) => c !== consultant),
                                  });
                                }
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={consultant.toLowerCase().replace(/\s+/g, "-")}
                            >
                              {consultant}
                            </label>
                          </div>
                        ))}

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="otherConsultant"
                            checked={formData.consultantType === "other"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setconsultantType('other')
                                setFormData({
                                  ...formData,
                                  consultantType: "other",
                                  consultants: [],
                                });
                              } else {
                                setconsultantType('')
                                setFormData({
                                  ...formData,
                                  consultantType: "",
                                  consultants: [],
                                });
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor="otherConsultant">
                            Others
                          </label>
                        </div>

                        {/* Dynamic Consultant Inputs */}
                        {formData.consultantType === "other" && (
                          <div className="mt-2">
                            <div className="row justify-content-end">
                              <div className="col-md-3">
                                <button
                                  type="button"
                                  className="btn addconsultantbtn"
                                  onClick={addConsultant}
                                >
                                  Add Consultant
                                </button>
                              </div>
                            </div>
                            <div className="row justify-content-start">
                              {formData.consultants.map((consultant, index) => (
                                <div className="col-md-6">
                                  <div key={index} className="d-flex align-items-center">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={`Consultant ${index + 1}`}
                                      value={consultant}
                                      onChange={(e) => updateConsultant(index, e.target.value)}
                                    />
                                    <p style={{ padding: '10px', cursor: 'pointer' }}
                                      onClick={() => removeConsultant(index)}
                                    >
                                      ❌
                                    </p>
                                  </div>
                                </div>

                              ))}

                            </div>

                          </div>
                        )}
                      </div>

                      {/* Contractors Section */}
                      <div className="mb-4">
                        <label className="form-label fw-bold">Contractors</label>

                        {["Civil"].map((contractor) => (
                          <div className="form-check" key={contractor}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={contractor.toLowerCase().replace(/\s+/g, "-")}
                              checked={formData.contractors.includes(contractor)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setcontractorType('')
                                  setFormData({
                                    ...formData,
                                    contractorType: "",
                                    contractors: [...formData.contractors, contractor],
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    contractors: formData.contractors.filter((c) => c !== contractor),
                                  });
                                }
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={contractor.toLowerCase().replace(/\s+/g, "-")}
                            >
                              {contractor}
                            </label>
                          </div>
                        ))}

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="otherContractor"
                            checked={formData.contractorType === "other"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setcontractorType('other')
                                setFormData({
                                  ...formData,
                                  contractorType: "other",
                                  contractors: [],
                                });
                              } else {
                                setcontractorType('')
                                setFormData({

                                  ...formData,
                                  contractorType: "",
                                  contractors: [],
                                });
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor="otherContractor">
                            Others
                          </label>
                        </div>

                        {/* Dynamic Contractor Inputs */}
                        {formData.contractorType === "other" && (
                          <div className="mt-2">
                            <div className="row justify-content-end">
                              <div className="col-md-3">
                                <button
                                  type="button"
                                  className="btn addconsultantbtn"
                                  onClick={addContractor}
                                >
                                  Add Contractor
                                </button>
                              </div>
                            </div>
                            <div className="row justify-content-start">
                              {formData.contractors.map((contractor, index) => (
                                <div className="col-md-6">
                                  <div key={index} className="d-flex align-items-center">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder={`Contractor ${index + 1}`}
                                      value={contractor}
                                      onChange={(e) => updateContractor(index, e.target.value)}
                                    />
                                    <p style={{ padding: '10px', cursor: 'pointer' }}
                                      onClick={() => removeContractor(index)}
                                    >
                                      ❌
                                    </p>
                                  </div>
                                </div>

                              ))}
                            </div>

                          </div>
                        )}
                      </div>
                    </div>
                    <p className="final-submit-note">
                      Note: Just to confirm, you are not buying the property you are submitting.
                    </p>

                    <div className="prestige-actions">
                      <button type="button" className="prestige-btn-back" onClick={(e) => handleBack(e, "step5")}>Back</button>
                      <button type="button" className="prestige-submit-btn" disabled={loading || uploadLoadingMainElevation || uploadLoadingSurveyor || uploadLoadingArchitect || isLoading3 || isLoadingOtherSideB || isLoading5 || isLoadingowner} onClick={(e) => handleSubmit(e)}>{loading ? "Submitting..." : "Submit"}</button>
                    </div>


                  </div>
                )}
              </form>
            </div> {/* End prestige-content */}
          </div> {/* End prestige-form-col */}
        </div> {/* End prestige-body */}
      </div> {/* End prestige-main-container */}
      <Modal show={paymentStatusModel} size="md" onHide={handleClose} centered>
        <Modal.Header>
          <div className="row justify-content-end">
            <span style={{ textAlign: 'end' }} onClick={handleClose}>X</span>
          </div>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">

          <div
            className="card-body"
            style={{
              borderRadius: "15px",
              maxWidth: "500px",
              background: paymentDone ? "#e6f9e6" : "#ffffff",
            }}
          >
            <div className="card-body">
              {paymentDone ? (
                <>
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
                    alt="Success"
                    width="80"
                  />
                  <h4 className="text-success mt-3">Payment Successful</h4>
                  <p className="text-muted">
                    Your payment has been processed successfully.
                  </p>
                </>
              ) : (
                <>
                  <div className="kyp-payment-acknowledgements">
                    <div className="kyp-payment-section">
                      <h4 className="kyp-payment-section-title">Ownership Certificate</h4>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={!!formData?.ownershipCertificateDeclaration}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              ownershipCertificateDeclaration: e.target.checked,
                            }))
                          }
                        />
                        <span>{OWNERSHIP_DECLARATION_LABEL}</span>
                      </label>
                    </div>

                    <div className="kyp-payment-section">
                      <h4 className="kyp-payment-section-title">Market Plan / Landuse Certificate</h4>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={formData?.marketPlanLandUseChoice === "applied"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              marketPlanLandUseChoice: e.target.checked ? "applied" : "",
                              noMasterPlanDeclaration: e.target.checked ? false : prev.noMasterPlanDeclaration,
                              noMasterPlanPropertyType: e.target.checked ? "" : prev.noMasterPlanPropertyType,
                            }))
                          }
                        />
                        <span>I have applied with department</span>
                      </label>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={formData?.marketPlanLandUseChoice === "upload60Days"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              marketPlanLandUseChoice: e.target.checked ? "upload60Days" : "",
                              noMasterPlanDeclaration: e.target.checked ? false : prev.noMasterPlanDeclaration,
                              noMasterPlanPropertyType: e.target.checked ? "" : prev.noMasterPlanPropertyType,
                            }))
                          }
                        />
                        <span>I will upload in 75 days for my property</span>
                      </label>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={!!formData?.noMasterPlanDeclaration}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              noMasterPlanDeclaration: e.target.checked,
                              marketPlanLandUseChoice: e.target.checked ? "" : prev.marketPlanLandUseChoice,
                              noMasterPlanPropertyType: e.target.checked
                                ? prev.noMasterPlanPropertyType
                                : "",
                            }))
                          }
                        />
                        <span>
                          Their is no exsisting master plan and it is not available with concenered MA & UD / Local Town Planing Department
                        </span>
                      </label>
                      {formData?.noMasterPlanDeclaration && (
                        <div className="ms-4 mt-2">
                          {Object.entries(NO_MASTER_PLAN_PROPERTY_TYPE_LABELS).map(
                            ([value, label]) => (
                              <label className="kyp-payment-check" key={value}>
                                <input
                                  type="checkbox"
                                  checked={formData?.noMasterPlanPropertyType === value}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      noMasterPlanPropertyType: e.target.checked ? value : "",
                                    }))
                                  }
                                />
                                <span>{label}</span>
                              </label>
                            )
                          )}
                        </div>
                      )}
                    </div>

                    <div className="kyp-payment-section">
                      <h4 className="kyp-payment-section-title">Bank Loan Support</h4>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={formData?.bankLoanChoice === "interested"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              bankLoanChoice: e.target.checked ? "interested" : "",
                            }))
                          }
                        />
                        <span>I am interested in bank loan in near future</span>
                      </label>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={formData?.bankLoanChoice === "sanctioned"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              bankLoanChoice: e.target.checked ? "sanctioned" : "",
                            }))
                          }
                        />
                        <span>I already have a bank loan on this property.</span>
                      </label>
                    </div>

                    <div className="kyp-payment-section">
                      <h4 className="kyp-payment-section-title">Title Possession Protection</h4>
                      <label className="kyp-payment-check">
                        <input
                          type="checkbox"
                          checked={!!formData?.titlePossessionConsent}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              titlePossessionConsent: e.target.checked,
                            }))
                          }
                        />
                        <span>In the future I give my consent to doCity to share my property details with banks and insurance companies and other government departments for the safety of the property</span>
                      </label>
                    </div>
                  </div>

                  <div className="kyp-payment-section">
                    <h4 className="kyp-payment-section-title">Aadhaar Verification</h4>
                    <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                      <input
                        type="text"
                        value={aadhaarNumber}
                        onChange={handleAadhaarNumberChange}
                        placeholder="Enter 12-digit Aadhaar number"
                        maxLength={12}
                        className="form-control"
                        style={{ height: "34px", fontSize: "14px", padding: "4px 10px" }}
                      />
                      {!isAadhaarVerified && (
                        <Button
                          variant="secondary"
                          onClick={handleSendAadhaarOtp}
                          disabled={isSendingAadhaarOtp || aadhaarNumber.length !== 12}
                          style={{ height: "34px", padding: "4px 12px", fontSize: "14px" }}
                        >
                          {isSendingAadhaarOtp ? "Sending..." : "Verify"}
                        </Button>
                      )}
                      {isAadhaarVerified && (
                        <span style={{ color: "var(--color-turquoise-teal)", alignSelf: "center", fontWeight: 600 }}>Verified ✓</span>
                      )}
                    </div>
                    {aadhaarError && <p className="error mb-0 mt-2">{aadhaarError}</p>}
                  </div>

                  <PaymentPreviewCard baseAmount={2000} gstRate={18} />
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {paymentDone ? (
            <Button variant="success" onClick={RouteToProperties}>
              Proceed to Properties
            </Button>
          ) : (
            <>
              <Button className="makePaymentButton" onClick={() => setOpenPaymentShow()} disabled={!isKypPayLaterEnabled}>
                Pay Now
              </Button>
              <Button variant="danger" onClick={handleClose}>
                Cancel Payment
              </Button>
              {/* <Button className="makePaymentButton" onClick={handlePayLaterKyp} disabled={!isKypPayLaterEnabled || isPayLaterLoadingKyp}>
                {isPayLaterLoadingKyp ? "Processing..." : "Pay Later"}
              </Button>
              {!isKypPayLaterEnabled && (
                <p className="kyp-paylater-hint mb-0">Complete all required selections to enable Pay Later.</p>
              )} */}
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={RazorPayShow} size="md" onHide={handleClose} centered>
        <Modal.Header>
          <div className="row setCenter">
            <div className="col-md-4">
              {paymentStatus === false && <div onClick={() => setRazorPayShow(false)}>X</div>}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <div
            className="card-body p-4 shadow-lg w-100 text-center"

          >

            <Product
              amount={2000}
              gstRate={18}
              currency="INR"
              paymentFor="knowYourProperty"
              userId={PropertyResponse?.userId}
              onPaymentStatusChange={setPaymentStatus}
              paymentRequestId={PropertyResponse}
              paymentMessage="KYP"
              paymentStatus={paymentStatus}
              SuccessStatus="beforeRequest"
            />
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="d-flex justify-content-center">
          {paymentStatus===true ? (
            <Button variant="success" onClick={RouteToProperties}>
              Proceed to Properties
            </Button>
          ) : (
            <>
              <Button variant="primary" onClick={() => setRazorPayShow(true)}>
                Make Payment
              </Button>
              <Button variant="danger" onClick={handleCancelPayment}>
                Cancel Payment
              </Button>
            </>
          )}

        </Modal.Footer> */}
      </Modal>
      <Modal show={showAadhaarOtpModal} size="sm" onHide={() => setShowAadhaarOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Verify Aadhaar OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            value={aadhaarOtp}
            onChange={handleAadhaarOtpChange}
            placeholder="Enter 6-digit OTP"
            maxLength={6}
            className="form-control"
          />
          {aadhaarError && <p className="error mt-2 mb-0">{aadhaarError}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAadhaarOtpModal(false)}>
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleVerifyAadhaarOtp}
            disabled={isVerifyingAadhaarOtp || aadhaarOtp.length !== 6}
          >
            {isVerifyingAadhaarOtp ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default KnowYourProperty;



